window.STICKER_CASE_BACKGROUND_PATTERNS = [
  {
    "id": "eclectic--abstract-art-colorful-paint-strokes",
    "name": "Abstract Art Colorful Paint Strokes",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/abstract-art-colorful-paint-strokes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/abstract-art-colorful-paint-strokes.jpg")
  },
  {
    "id": "eclectic--abstract-black-scribble-line-art",
    "name": "Abstract Black Scribble Line Art",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/abstract-black-scribble-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/abstract-black-scribble-line-art.jpg")
  },
  {
    "id": "eclectic--balance-black-organic-contour-lines",
    "name": "Balance Black Organic Contour Lines",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/balance-black-organic-contour-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/balance-black-organic-contour-lines.jpg")
  },
  {
    "id": "eclectic--bauhaus-black-curves-orange-circles-on-pink",
    "name": "Bauhaus Black Curves Orange Circles On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-black-curves-orange-circles-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-black-curves-orange-circles-on-pink.jpg")
  },
  {
    "id": "eclectic--bauhaus-blue-diamond-checkerboard",
    "name": "Bauhaus Blue Diamond Checkerboard",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-blue-diamond-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-blue-diamond-checkerboard.jpg")
  },
  {
    "id": "eclectic--bauhaus-blue-spiral-pink-semicircle",
    "name": "Bauhaus Blue Spiral Pink Semicircle",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-blue-spiral-pink-semicircle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-blue-spiral-pink-semicircle.jpg")
  },
  {
    "id": "eclectic--bauhaus-colorful-connected-circle-shapes",
    "name": "Bauhaus Colorful Connected Circle Shapes",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-colorful-connected-circle-shapes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-colorful-connected-circle-shapes.jpg")
  },
  {
    "id": "eclectic--bauhaus-green-triangles-and-squares",
    "name": "Bauhaus Green Triangles And Squares",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-green-triangles-and-squares.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-green-triangles-and-squares.jpg")
  },
  {
    "id": "eclectic--bauhaus-red-semicircle-blue-concentric-lines",
    "name": "Bauhaus Red Semicircle Blue Concentric Lines",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bauhaus-red-semicircle-blue-concentric-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bauhaus-red-semicircle-blue-concentric-lines.jpg")
  },
  {
    "id": "eclectic--be-cool-orange-doodle-flower",
    "name": "Be Cool Orange Doodle Flower",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/be-cool-orange-doodle-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/be-cool-orange-doodle-flower.jpg")
  },
  {
    "id": "eclectic--be-kind-always-yellow-botanical-shape",
    "name": "Be Kind Always Yellow Botanical Shape",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/be-kind-always-yellow-botanical-shape.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/be-kind-always-yellow-botanical-shape.jpg")
  },
  {
    "id": "eclectic--believe-in-yourself-pink-on-yellow",
    "name": "Believe In Yourself Pink On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/believe-in-yourself-pink-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/believe-in-yourself-pink-on-yellow.jpg")
  },
  {
    "id": "eclectic--black-abstract-mirrored-organic-shapes",
    "name": "Black Abstract Mirrored Organic Shapes",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/black-abstract-mirrored-organic-shapes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/black-abstract-mirrored-organic-shapes.jpg")
  },
  {
    "id": "eclectic--black-line-flower-in-vase-on-yellow",
    "name": "Black Line Flower In Vase On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/black-line-flower-in-vase-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/black-line-flower-in-vase-on-yellow.jpg")
  },
  {
    "id": "eclectic--bloom-blue-lily-line-art",
    "name": "Bloom Blue Lily Line Art",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bloom-blue-lily-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bloom-blue-lily-line-art.jpg")
  },
  {
    "id": "eclectic--bloom-red-flowers-blue-leaves",
    "name": "Bloom Red Flowers Blue Leaves",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bloom-red-flowers-blue-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bloom-red-flowers-blue-leaves.jpg")
  },
  {
    "id": "eclectic--bloom-where-you-are-planted-pink-daisy",
    "name": "Bloom Where You Are Planted Pink Daisy",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bloom-where-you-are-planted-pink-daisy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bloom-where-you-are-planted-pink-daisy.jpg")
  },
  {
    "id": "eclectic--bon-appetit-pink-on-blue",
    "name": "Bon Appetit Pink On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bon-appetit-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bon-appetit-pink-on-blue.jpg")
  },
  {
    "id": "eclectic--bon-appetit-red-cherries-on-pink",
    "name": "Bon Appetit Red Cherries On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/bon-appetit-red-cherries-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/bon-appetit-red-cherries-on-pink.jpg")
  },
  {
    "id": "eclectic--cheers-three-hands-with-cocktail-glasses",
    "name": "Cheers Three Hands With Cocktail Glasses",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/cheers-three-hands-with-cocktail-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/cheers-three-hands-with-cocktail-glasses.jpg")
  },
  {
    "id": "eclectic--ciao-bella-pink-daisy-on-red",
    "name": "Ciao Bella Pink Daisy On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/ciao-bella-pink-daisy-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/ciao-bella-pink-daisy-on-red.jpg")
  },
  {
    "id": "eclectic--ciao-bella-pink-flower-on-orange",
    "name": "Ciao Bella Pink Flower On Orange",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/ciao-bella-pink-flower-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/ciao-bella-pink-flower-on-orange.jpg")
  },
  {
    "id": "eclectic--ciao-yellow-starburst-on-blue",
    "name": "Ciao Yellow Starburst On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/ciao-yellow-starburst-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/ciao-yellow-starburst-on-blue.jpg")
  },
  {
    "id": "eclectic--cin-cin-red-on-pink",
    "name": "Cin Cin Red On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/cin-cin-red-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/cin-cin-red-on-pink.jpg")
  },
  {
    "id": "eclectic--coffee-please-pink-checkered-cup",
    "name": "Coffee Please Pink Checkered Cup",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/coffee-please-pink-checkered-cup.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/coffee-please-pink-checkered-cup.jpg")
  },
  {
    "id": "eclectic--coffee-white-moka-pot-on-blue",
    "name": "Coffee White Moka Pot On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/coffee-white-moka-pot-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/coffee-white-moka-pot-on-blue.jpg")
  },
  {
    "id": "eclectic--cool-people-live-here-on-yellow",
    "name": "Cool People Live Here On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/cool-people-live-here-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/cool-people-live-here-on-yellow.jpg")
  },
  {
    "id": "eclectic--dance-repeated-blue-lettering",
    "name": "Dance Repeated Blue Lettering",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/dance-repeated-blue-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/dance-repeated-blue-lettering.jpg")
  },
  {
    "id": "eclectic--do-more-of-the-things-you-enjoy",
    "name": "Do More Of The Things You Enjoy",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/do-more-of-the-things-you-enjoy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/do-more-of-the-things-you-enjoy.jpg")
  },
  {
    "id": "eclectic--do-more-of-what-you-love-blue-on-pink",
    "name": "Do More Of What You Love Blue On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/do-more-of-what-you-love-blue-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/do-more-of-what-you-love-blue-on-pink.jpg")
  },
  {
    "id": "eclectic--do-more-of-what-you-love-yellow-on-pink",
    "name": "Do More Of What You Love Yellow On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/do-more-of-what-you-love-yellow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/do-more-of-what-you-love-yellow-on-pink.jpg")
  },
  {
    "id": "eclectic--dont-overthink-it-blue-squiggles",
    "name": "Dont Overthink It Blue Squiggles",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/dont-overthink-it-blue-squiggles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/dont-overthink-it-blue-squiggles.jpg")
  },
  {
    "id": "eclectic--drink-up-cherry-cocktail-on-pink",
    "name": "Drink Up Cherry Cocktail On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/drink-up-cherry-cocktail-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/drink-up-cherry-cocktail-on-pink.jpg")
  },
  {
    "id": "eclectic--eat-green-watercolor-avocado",
    "name": "Eat Green Watercolor Avocado",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/eat-green-watercolor-avocado.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/eat-green-watercolor-avocado.jpg")
  },
  {
    "id": "eclectic--enjoy-the-little-things-on-orange",
    "name": "Enjoy The Little Things On Orange",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/enjoy-the-little-things-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/enjoy-the-little-things-on-orange.jpg")
  },
  {
    "id": "eclectic--flower-garden-pink-on-red",
    "name": "Flower Garden Pink On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/flower-garden-pink-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/flower-garden-pink-on-red.jpg")
  },
  {
    "id": "eclectic--flower-market-orange-bell-flowers",
    "name": "Flower Market Orange Bell Flowers",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/flower-market-orange-bell-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/flower-market-orange-bell-flowers.jpg")
  },
  {
    "id": "eclectic--flower-market-pink-daisies-on-red",
    "name": "Flower Market Pink Daisies On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/flower-market-pink-daisies-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/flower-market-pink-daisies-on-red.jpg")
  },
  {
    "id": "eclectic--flower-power-three-pink-daisies",
    "name": "Flower Power Three Pink Daisies",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/flower-power-three-pink-daisies.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/flower-power-three-pink-daisies.jpg")
  },
  {
    "id": "eclectic--freedom-blue-figure-orange-sun",
    "name": "Freedom Blue Figure Orange Sun",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/freedom-blue-figure-orange-sun.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/freedom-blue-figure-orange-sun.jpg")
  },
  {
    "id": "eclectic--fresh-strawberry-blue-line-art",
    "name": "Fresh Strawberry Blue Line Art",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/fresh-strawberry-blue-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/fresh-strawberry-blue-line-art.jpg")
  },
  {
    "id": "eclectic--good-things-come-to-those-who-create",
    "name": "Good Things Come To Those Who Create",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/good-things-come-to-those-who-create.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/good-things-come-to-those-who-create.jpg")
  },
  {
    "id": "eclectic--good-things-take-time-green-lettering",
    "name": "Good Things Take Time Green Lettering",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/good-things-take-time-green-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/good-things-take-time-green-lettering.jpg")
  },
  {
    "id": "eclectic--good-time-bow-tied-cocktail-glasses",
    "name": "Good Time Bow Tied Cocktail Glasses",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/good-time-bow-tied-cocktail-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/good-time-bow-tied-cocktail-glasses.jpg")
  },
  {
    "id": "eclectic--good-vibes-great-love-pink-frame",
    "name": "Good Vibes Great Love Pink Frame",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/good-vibes-great-love-pink-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/good-vibes-great-love-pink-frame.jpg")
  },
  {
    "id": "eclectic--good-vibes-only-pink-on-blue",
    "name": "Good Vibes Only Pink On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/good-vibes-only-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/good-vibes-only-pink-on-blue.jpg")
  },
  {
    "id": "eclectic--green-striped-swimsuit-line-art",
    "name": "Green Striped Swimsuit Line Art",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/green-striped-swimsuit-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/green-striped-swimsuit-line-art.jpg")
  },
  {
    "id": "eclectic--here-comes-the-sun-on-orange",
    "name": "Here Comes The Sun On Orange",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/here-comes-the-sun-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/here-comes-the-sun-on-orange.jpg")
  },
  {
    "id": "eclectic--hi-orange-starburst-on-yellow",
    "name": "Hi Orange Starburst On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/hi-orange-starburst-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/hi-orange-starburst-on-yellow.jpg")
  },
  {
    "id": "eclectic--how-lucky-am-i-yellow-on-blue",
    "name": "How Lucky Am I Yellow On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/how-lucky-am-i-yellow-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/how-lucky-am-i-yellow-on-blue.jpg")
  },
  {
    "id": "eclectic--i-am-a-priority-seated-figure",
    "name": "I Am A Priority Seated Figure",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/i-am-a-priority-seated-figure.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/i-am-a-priority-seated-figure.jpg")
  },
  {
    "id": "eclectic--i-am-worthy-affirmation-on-pink",
    "name": "I Am Worthy Affirmation On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/i-am-worthy-affirmation-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/i-am-worthy-affirmation-on-pink.jpg")
  },
  {
    "id": "eclectic--illusion-white-starburst-on-blue",
    "name": "Illusion White Starburst On Blue",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/illusion-white-starburst-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/illusion-white-starburst-on-blue.jpg")
  },
  {
    "id": "eclectic--in-my-happy-girl-era-pink-heart",
    "name": "In My Happy Girl Era Pink Heart",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/in-my-happy-girl-era-pink-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/in-my-happy-girl-era-pink-heart.jpg")
  },
  {
    "id": "eclectic--keep-going-youre-closer-than-you-think",
    "name": "Keep Going Youre Closer Than You Think",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/keep-going-youre-closer-than-you-think.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/keep-going-youre-closer-than-you-think.jpg")
  },
  {
    "id": "eclectic--la-vie-est-belle-red-lettering",
    "name": "La Vie Est Belle Red Lettering",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/la-vie-est-belle-red-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/la-vie-est-belle-red-lettering.jpg")
  },
  {
    "id": "eclectic--large-orange-flower-on-pink",
    "name": "Large Orange Flower On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/large-orange-flower-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/large-orange-flower-on-pink.jpg")
  },
  {
    "id": "eclectic--large-pink-ribbon-bow-on-red",
    "name": "Large Pink Ribbon Bow On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/large-pink-ribbon-bow-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/large-pink-ribbon-bow-on-red.jpg")
  },
  {
    "id": "eclectic--love-you-two-red-hearts-on-pink",
    "name": "Love You Two Red Hearts On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/love-you-two-red-hearts-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/love-you-two-red-hearts-on-pink.jpg")
  },
  {
    "id": "eclectic--ma-cherie-red-cherries",
    "name": "Ma Cherie Red Cherries",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/ma-cherie-red-cherries.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/ma-cherie-red-cherries.jpg")
  },
  {
    "id": "eclectic--make-your-own-magic-on-orange",
    "name": "Make Your Own Magic On Orange",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/make-your-own-magic-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/make-your-own-magic-on-orange.jpg")
  },
  {
    "id": "eclectic--matcha-club-green-latte-cup",
    "name": "Matcha Club Green Latte Cup",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/matcha-club-green-latte-cup.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/matcha-club-green-latte-cup.jpg")
  },
  {
    "id": "eclectic--modern-art-green-botanical-cutout",
    "name": "Modern Art Green Botanical Cutout",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/modern-art-green-botanical-cutout.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/modern-art-green-botanical-cutout.jpg")
  },
  {
    "id": "eclectic--modo-creativo-on-switch",
    "name": "Modo Creativo On Switch",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/modo-creativo-on-switch.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/modo-creativo-on-switch.jpg")
  },
  {
    "id": "eclectic--more-amor-por-favor-pink-on-black",
    "name": "More Amor Por Favor Pink On Black",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/more-amor-por-favor-pink-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/more-amor-por-favor-pink-on-black.jpg")
  },
  {
    "id": "eclectic--more-amore-por-favor-black-lettering",
    "name": "More Amore Por Favor Black Lettering",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/more-amore-por-favor-black-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/more-amore-por-favor-black-lettering.jpg")
  },
  {
    "id": "eclectic--more-amore-por-favor-on-red",
    "name": "More Amore Por Favor On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/more-amore-por-favor-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/more-amore-por-favor-on-red.jpg")
  },
  {
    "id": "eclectic--no-rain-no-flowers-black-botanical",
    "name": "No Rain No Flowers Black Botanical",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/no-rain-no-flowers-black-botanical.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/no-rain-no-flowers-black-botanical.jpg")
  },
  {
    "id": "eclectic--oui-oui-croissant-blue-line-art",
    "name": "Oui Oui Croissant Blue Line Art",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/oui-oui-croissant-blue-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/oui-oui-croissant-blue-line-art.jpg")
  },
  {
    "id": "eclectic--pasta-black-curved-tube-lines",
    "name": "Pasta Black Curved Tube Lines",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/pasta-black-curved-tube-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/pasta-black-curved-tube-lines.jpg")
  },
  {
    "id": "eclectic--pasta-lover-blue-checkerboard",
    "name": "Pasta Lover Blue Checkerboard",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/pasta-lover-blue-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/pasta-lover-blue-checkerboard.jpg")
  },
  {
    "id": "eclectic--pasta-lover-club-spaghetti-blue-plate",
    "name": "Pasta Lover Club Spaghetti Blue Plate",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/pasta-lover-club-spaghetti-blue-plate.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/pasta-lover-club-spaghetti-blue-plate.jpg")
  },
  {
    "id": "eclectic--pink-flower-blue-geometric-vase",
    "name": "Pink Flower Blue Geometric Vase",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/pink-flower-blue-geometric-vase.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/pink-flower-blue-geometric-vase.jpg")
  },
  {
    "id": "eclectic--purple-daisies-flower",
    "name": "Purple Daisies Flower",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/purple-daisies-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/purple-daisies-flower.jpg")
  },
  {
    "id": "eclectic--reclining-figure-blue-striped-fabric",
    "name": "Reclining Figure Blue Striped Fabric",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/reclining-figure-blue-striped-fabric.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/reclining-figure-blue-striped-fabric.jpg")
  },
  {
    "id": "eclectic--red-cherries-with-bow-on-pink-stripes",
    "name": "Red Cherries With Bow On Pink Stripes",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/red-cherries-with-bow-on-pink-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/red-cherries-with-bow-on-pink-stripes.jpg")
  },
  {
    "id": "eclectic--red-cherry-with-bow-in-pink-looped-frame",
    "name": "Red Cherry With Bow In Pink Looped Frame",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/red-cherry-with-bow-in-pink-looped-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/red-cherry-with-bow-in-pink-looped-frame.jpg")
  },
  {
    "id": "eclectic--red-flower-blue-vase-checkerboard",
    "name": "Red Flower Blue Vase Checkerboard",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/red-flower-blue-vase-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/red-flower-blue-vase-checkerboard.jpg")
  },
  {
    "id": "eclectic--red-radial-rays-gratitude-on-pink",
    "name": "Red Radial Rays Gratitude On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/red-radial-rays-gratitude-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/red-radial-rays-gratitude-on-pink.jpg")
  },
  {
    "id": "eclectic--seated-woman-with-stars-on-yellow",
    "name": "Seated Woman With Stars On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/seated-woman-with-stars-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/seated-woman-with-stars-on-yellow.jpg")
  },
  {
    "id": "eclectic--shine-for-yourself-orange-on-yellow",
    "name": "Shine For Yourself Orange On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/shine-for-yourself-orange-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/shine-for-yourself-orange-on-yellow.jpg")
  },
  {
    "id": "eclectic--smile-blue-faces-on-yellow",
    "name": "Smile Blue Faces On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/smile-blue-faces-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/smile-blue-faces-on-yellow.jpg")
  },
  {
    "id": "eclectic--spicy-red-chili-pepper",
    "name": "Spicy Red Chili Pepper",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/spicy-red-chili-pepper.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/spicy-red-chili-pepper.jpg")
  },
  {
    "id": "eclectic--spring-pink-flowers-blue-leaves",
    "name": "Spring Pink Flowers Blue Leaves",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/spring-pink-flowers-blue-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/spring-pink-flowers-blue-leaves.jpg")
  },
  {
    "id": "eclectic--strawberries-in-red-grid-frame",
    "name": "Strawberries In Red Grid Frame",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/strawberries-in-red-grid-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/strawberries-in-red-grid-frame.jpg")
  },
  {
    "id": "eclectic--summer-orange-starburst-on-yellow",
    "name": "Summer Orange Starburst On Yellow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/summer-orange-starburst-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/summer-orange-starburst-on-yellow.jpg")
  },
  {
    "id": "eclectic--take-the-risk-smiling-daisy",
    "name": "Take The Risk Smiling Daisy",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/take-the-risk-smiling-daisy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/take-the-risk-smiling-daisy.jpg")
  },
  {
    "id": "eclectic--talk-less-do-more-pink-smiley",
    "name": "Talk Less Do More Pink Smiley",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/talk-less-do-more-pink-smiley.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/talk-less-do-more-pink-smiley.jpg")
  },
  {
    "id": "eclectic--tea-time-green-and-blue-cup",
    "name": "Tea Time Green And Blue Cup",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/tea-time-green-and-blue-cup.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/tea-time-green-and-blue-cup.jpg")
  },
  {
    "id": "eclectic--there-is-art-in-everything-red-contours",
    "name": "There Is Art In Everything Red Contours",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/there-is-art-in-everything-red-contours.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/there-is-art-in-everything-red-contours.jpg")
  },
  {
    "id": "eclectic--think-less-and-do-more-on-orange",
    "name": "Think Less And Do More On Orange",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/think-less-and-do-more-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/think-less-and-do-more-on-orange.jpg")
  },
  {
    "id": "eclectic--time-for-spritz-two-cocktail-glasses",
    "name": "Time For Spritz Two Cocktail Glasses",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/time-for-spritz-two-cocktail-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/time-for-spritz-two-cocktail-glasses.jpg")
  },
  {
    "id": "eclectic--trust-yourself-white-heart-on-red",
    "name": "Trust Yourself White Heart On Red",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/trust-yourself-white-heart-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/trust-yourself-white-heart-on-red.jpg")
  },
  {
    "id": "eclectic--white-cat-in-pink-striped-frame",
    "name": "White Cat In Pink Striped Frame",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/white-cat-in-pink-striped-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/white-cat-in-pink-striped-frame.jpg")
  },
  {
    "id": "eclectic--yellow-lemon-on-blue-stripes",
    "name": "Yellow Lemon On Blue Stripes",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/yellow-lemon-on-blue-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/yellow-lemon-on-blue-stripes.jpg")
  },
  {
    "id": "eclectic--yellow-tulips-flower-market-on-pink",
    "name": "Yellow Tulips Flower Market On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/yellow-tulips-flower-market-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/yellow-tulips-flower-market-on-pink.jpg")
  },
  {
    "id": "eclectic--you-are-loved-red-ribbon-bow",
    "name": "You Are Loved Red Ribbon Bow",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/you-are-loved-red-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/you-are-loved-red-ribbon-bow.jpg")
  },
  {
    "id": "eclectic--you-are-so-loved-red-heart",
    "name": "You Are So Loved Red Heart",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/you-are-so-loved-red-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/you-are-so-loved-red-heart.jpg")
  },
  {
    "id": "eclectic--you-can-do-hard-things-on-pink",
    "name": "You Can Do Hard Things On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/you-can-do-hard-things-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/you-can-do-hard-things-on-pink.jpg")
  },
  {
    "id": "eclectic--you-got-this-red-on-pink",
    "name": "You Got This Red On Pink",
    "category": "Eclectic",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic/you-got-this-red-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic/you-got-this-red-on-pink.jpg")
  },
  {
    "id": "wall--always-happiness-smiling-daisies",
    "name": "Always Happiness Smiling Daisies",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/always-happiness-smiling-daisies.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/always-happiness-smiling-daisies.jpg")
  },
  {
    "id": "wall--always-stay-positive-daisy-blue-checkerboard",
    "name": "Always Stay Positive Daisy Blue Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/always-stay-positive-daisy-blue-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/always-stay-positive-daisy-blue-checkerboard.jpg")
  },
  {
    "id": "wall--art-will-save-us-mountain-landscape",
    "name": "Art Will Save Us Mountain Landscape",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/art-will-save-us-mountain-landscape.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/art-will-save-us-mountain-landscape.jpg")
  },
  {
    "id": "wall--autumn-pumpkin-pie-slice",
    "name": "Autumn Pumpkin Pie Slice",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/autumn-pumpkin-pie-slice.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/autumn-pumpkin-pie-slice.jpg")
  },
  {
    "id": "wall--be-yourself-love-yourself-pastel-heart",
    "name": "Be Yourself Love Yourself Pastel Heart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/be-yourself-love-yourself-pastel-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/be-yourself-love-yourself-pastel-heart.jpg")
  },
  {
    "id": "wall--beauty-begins-be-yourself-face-line-art",
    "name": "Beauty Begins Be Yourself Face Line Art",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/beauty-begins-be-yourself-face-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/beauty-begins-be-yourself-face-line-art.jpg")
  },
  {
    "id": "wall--believe-in-your-potential-abstract-figure",
    "name": "Believe In Your Potential Abstract Figure",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/believe-in-your-potential-abstract-figure.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/believe-in-your-potential-abstract-figure.jpg")
  },
  {
    "id": "wall--black-and-white-eye-pattern-on-pink",
    "name": "Black And White Eye Pattern On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/black-and-white-eye-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/black-and-white-eye-pattern-on-pink.jpg")
  },
  {
    "id": "wall--black-and-white-eye-pattern-on-turquoise",
    "name": "Black And White Eye Pattern On Turquoise",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/black-and-white-eye-pattern-on-turquoise.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/black-and-white-eye-pattern-on-turquoise.jpg")
  },
  {
    "id": "wall--black-cherries-on-pink-waves",
    "name": "Black Cherries On Pink Waves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/black-cherries-on-pink-waves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/black-cherries-on-pink-waves.jpg")
  },
  {
    "id": "wall--bloom-yellow-flower-on-hot-pink",
    "name": "Bloom Yellow Flower On Hot Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/bloom-yellow-flower-on-hot-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/bloom-yellow-flower-on-hot-pink.jpg")
  },
  {
    "id": "wall--breakfast-cartoon-egg-and-bacon",
    "name": "Breakfast Cartoon Egg And Bacon",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/breakfast-cartoon-egg-and-bacon.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/breakfast-cartoon-egg-and-bacon.jpg")
  },
  {
    "id": "wall--breathe-white-face-line-art-on-blue",
    "name": "Breathe White Face Line Art On Blue",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/breathe-white-face-line-art-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/breathe-white-face-line-art-on-blue.jpg")
  },
  {
    "id": "wall--celebrate-life-dancing-smiley-flower",
    "name": "Celebrate Life Dancing Smiley Flower",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/celebrate-life-dancing-smiley-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/celebrate-life-dancing-smiley-flower.jpg")
  },
  {
    "id": "wall--cheers-pink-coupe-glass-with-bow",
    "name": "Cheers Pink Coupe Glass With Bow",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/cheers-pink-coupe-glass-with-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/cheers-pink-coupe-glass-with-bow.jpg")
  },
  {
    "id": "wall--chill-red-lettering-on-pink",
    "name": "Chill Red Lettering On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/chill-red-lettering-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/chill-red-lettering-on-pink.jpg")
  },
  {
    "id": "wall--coffee-shop-daisy-character-blue-checkerboard",
    "name": "Coffee Shop Daisy Character Blue Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/coffee-shop-daisy-character-blue-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/coffee-shop-daisy-character-blue-checkerboard.jpg")
  },
  {
    "id": "wall--courage-to-begin-again-pink-flower",
    "name": "Courage To Begin Again Pink Flower",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/courage-to-begin-again-pink-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/courage-to-begin-again-pink-flower.jpg")
  },
  {
    "id": "wall--cowboy-boot-and-stars-line-art",
    "name": "Cowboy Boot And Stars Line Art",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/cowboy-boot-and-stars-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/cowboy-boot-and-stars-line-art.jpg")
  },
  {
    "id": "wall--cream-daisies-on-orange-waves",
    "name": "Cream Daisies On Orange Waves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/cream-daisies-on-orange-waves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/cream-daisies-on-orange-waves.jpg")
  },
  {
    "id": "wall--crescent-moon-orbits-universe-quote",
    "name": "Crescent Moon Orbits Universe Quote",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/crescent-moon-orbits-universe-quote.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/crescent-moon-orbits-universe-quote.jpg")
  },
  {
    "id": "wall--daily-affirmation-pastel-gradient",
    "name": "Daily Affirmation Pastel Gradient",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/daily-affirmation-pastel-gradient.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/daily-affirmation-pastel-gradient.jpg")
  },
  {
    "id": "wall--disco-ball-on-pink-checkerboard",
    "name": "Disco Ball On Pink Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/disco-ball-on-pink-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/disco-ball-on-pink-checkerboard.jpg")
  },
  {
    "id": "wall--do-more-worry-less-pastel-gradient",
    "name": "Do More Worry Less Pastel Gradient",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/do-more-worry-less-pastel-gradient.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/do-more-worry-less-pastel-gradient.jpg")
  },
  {
    "id": "wall--do-what-you-love-yellow-on-pink",
    "name": "Do What You Love Yellow On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/do-what-you-love-yellow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/do-what-you-love-yellow-on-pink.jpg")
  },
  {
    "id": "wall--do-what-you-love-yellow-starburst",
    "name": "Do What You Love Yellow Starburst",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/do-what-you-love-yellow-starburst.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/do-what-you-love-yellow-starburst.jpg")
  },
  {
    "id": "wall--dream-big-plan-well-on-pink",
    "name": "Dream Big Plan Well On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/dream-big-plan-well-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/dream-big-plan-well-on-pink.jpg")
  },
  {
    "id": "wall--embrace-the-beauty-of-now-glowing-smiley",
    "name": "Embrace The Beauty Of Now Glowing Smiley",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/embrace-the-beauty-of-now-glowing-smiley.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/embrace-the-beauty-of-now-glowing-smiley.jpg")
  },
  {
    "id": "wall--everything-happens-for-a-reason-red-waves",
    "name": "Everything Happens For A Reason Red Waves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/everything-happens-for-a-reason-red-waves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/everything-happens-for-a-reason-red-waves.jpg")
  },
  {
    "id": "wall--feelin-peachy-cute-smiling-peach",
    "name": "Feelin Peachy Cute Smiling Peach",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/feelin-peachy-cute-smiling-peach.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/feelin-peachy-cute-smiling-peach.jpg")
  },
  {
    "id": "wall--flower-market-magenta-daisy",
    "name": "Flower Market Magenta Daisy",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/flower-market-magenta-daisy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/flower-market-magenta-daisy.jpg")
  },
  {
    "id": "wall--flower-market-pink-petals-teal-leaves",
    "name": "Flower Market Pink Petals Teal Leaves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/flower-market-pink-petals-teal-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/flower-market-pink-petals-teal-leaves.jpg")
  },
  {
    "id": "wall--flower-market-pink-tulips-green-leaves",
    "name": "Flower Market Pink Tulips Green Leaves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/flower-market-pink-tulips-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/flower-market-pink-tulips-green-leaves.jpg")
  },
  {
    "id": "wall--full-time-pasta-lover-spaghetti",
    "name": "Full Time Pasta Lover Spaghetti",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/full-time-pasta-lover-spaghetti.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/full-time-pasta-lover-spaghetti.jpg")
  },
  {
    "id": "wall--glossy-pink-heart-grid",
    "name": "Glossy Pink Heart Grid",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/glossy-pink-heart-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/glossy-pink-heart-grid.jpg")
  },
  {
    "id": "wall--good-food-good-mood-cherry-tart",
    "name": "Good Food Good Mood Cherry Tart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/good-food-good-mood-cherry-tart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/good-food-good-mood-cherry-tart.jpg")
  },
  {
    "id": "wall--gratitude-blue-botanical-cutout",
    "name": "Gratitude Blue Botanical Cutout",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/gratitude-blue-botanical-cutout.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/gratitude-blue-botanical-cutout.jpg")
  },
  {
    "id": "wall--heart-shaped-cherries-with-pink-bow",
    "name": "Heart Shaped Cherries With Pink Bow",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/heart-shaped-cherries-with-pink-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/heart-shaped-cherries-with-pink-bow.jpg")
  },
  {
    "id": "wall--hippie-market-colorful-smiley-flowers",
    "name": "Hippie Market Colorful Smiley Flowers",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/hippie-market-colorful-smiley-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/hippie-market-colorful-smiley-flowers.jpg")
  },
  {
    "id": "wall--i-am-always-protected-blue-evil-eye",
    "name": "I Am Always Protected Blue Evil Eye",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/i-am-always-protected-blue-evil-eye.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/i-am-always-protected-blue-evil-eye.jpg")
  },
  {
    "id": "wall--i-am-worthy-smiling-daisy",
    "name": "I Am Worthy Smiling Daisy",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/i-am-worthy-smiling-daisy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/i-am-worthy-smiling-daisy.jpg")
  },
  {
    "id": "wall--iridescent-pink-heart-grid",
    "name": "Iridescent Pink Heart Grid",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/iridescent-pink-heart-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/iridescent-pink-heart-grid.jpg")
  },
  {
    "id": "wall--iridescent-pink-heart-on-gradient",
    "name": "Iridescent Pink Heart On Gradient",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/iridescent-pink-heart-on-gradient.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/iridescent-pink-heart-on-gradient.jpg")
  },
  {
    "id": "wall--keep-going-pink-flowers-on-blue",
    "name": "Keep Going Pink Flowers On Blue",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/keep-going-pink-flowers-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/keep-going-pink-flowers-on-blue.jpg")
  },
  {
    "id": "wall--keep-going-pink-lettering-blue-sky",
    "name": "Keep Going Pink Lettering Blue Sky",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/keep-going-pink-lettering-blue-sky.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/keep-going-pink-lettering-blue-sky.jpg")
  },
  {
    "id": "wall--love-definition-pastel-aura",
    "name": "Love Definition Pastel Aura",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/love-definition-pastel-aura.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/love-definition-pastel-aura.jpg")
  },
  {
    "id": "wall--love-four-glossy-pink-hearts",
    "name": "Love Four Glossy Pink Hearts",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/love-four-glossy-pink-hearts.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/love-four-glossy-pink-hearts.jpg")
  },
  {
    "id": "wall--love-is-the-highest-vibration-smiling-heart",
    "name": "Love Is The Highest Vibration Smiling Heart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/love-is-the-highest-vibration-smiling-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/love-is-the-highest-vibration-smiling-heart.jpg")
  },
  {
    "id": "wall--love-more-worry-less-on-pink",
    "name": "Love More Worry Less On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/love-more-worry-less-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/love-more-worry-less-on-pink.jpg")
  },
  {
    "id": "wall--lucky-black-eight-ball",
    "name": "Lucky Black Eight Ball",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/lucky-black-eight-ball.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/lucky-black-eight-ball.jpg")
  },
  {
    "id": "wall--lunch-spaghetti-line-art-pink-checkerboard",
    "name": "Lunch Spaghetti Line Art Pink Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/lunch-spaghetti-line-art-pink-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/lunch-spaghetti-line-art-pink-checkerboard.jpg")
  },
  {
    "id": "wall--manifest-your-dreams-pink-flowers",
    "name": "Manifest Your Dreams Pink Flowers",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/manifest-your-dreams-pink-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/manifest-your-dreams-pink-flowers.jpg")
  },
  {
    "id": "wall--matisse-pink-flower-green-leaves",
    "name": "Matisse Pink Flower Green Leaves",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/matisse-pink-flower-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/matisse-pink-flower-green-leaves.jpg")
  },
  {
    "id": "wall--matisse-pink-purple-blue-floral-cutouts",
    "name": "Matisse Pink Purple Blue Floral Cutouts",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/matisse-pink-purple-blue-floral-cutouts.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/matisse-pink-purple-blue-floral-cutouts.jpg")
  },
  {
    "id": "wall--melting-yellow-smiley-green-checkerboard",
    "name": "Melting Yellow Smiley Green Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/melting-yellow-smiley-green-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/melting-yellow-smiley-green-checkerboard.jpg")
  },
  {
    "id": "wall--mint-green-daisy-grid-on-lavender",
    "name": "Mint Green Daisy Grid On Lavender",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/mint-green-daisy-grid-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/mint-green-daisy-grid-on-lavender.jpg")
  },
  {
    "id": "wall--my-energy-is-meant-for-me-first-heart",
    "name": "My Energy Is Meant For Me First Heart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/my-energy-is-meant-for-me-first-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/my-energy-is-meant-for-me-first-heart.jpg")
  },
  {
    "id": "wall--overthinking-nested-head-outlines",
    "name": "Overthinking Nested Head Outlines",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/overthinking-nested-head-outlines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/overthinking-nested-head-outlines.jpg")
  },
  {
    "id": "wall--overthinking-white-head-outlines-on-green",
    "name": "Overthinking White Head Outlines On Green",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/overthinking-white-head-outlines-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/overthinking-white-head-outlines-on-green.jpg")
  },
  {
    "id": "wall--party-martini-glass-line-art",
    "name": "Party Martini Glass Line Art",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/party-martini-glass-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/party-martini-glass-line-art.jpg")
  },
  {
    "id": "wall--pink-and-blue-stacked-geometric-circles",
    "name": "Pink And Blue Stacked Geometric Circles",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-and-blue-stacked-geometric-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-and-blue-stacked-geometric-circles.jpg")
  },
  {
    "id": "wall--pink-flowers-on-wavy-checkerboard",
    "name": "Pink Flowers On Wavy Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-flowers-on-wavy-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-flowers-on-wavy-checkerboard.jpg")
  },
  {
    "id": "wall--pink-heart-orange-checkerboard",
    "name": "Pink Heart Orange Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-heart-orange-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-heart-orange-checkerboard.jpg")
  },
  {
    "id": "wall--pink-heart-soul-and-feelings-quote",
    "name": "Pink Heart Soul And Feelings Quote",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-heart-soul-and-feelings-quote.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-heart-soul-and-feelings-quote.jpg")
  },
  {
    "id": "wall--pink-mushroom-life-is-a-vibe",
    "name": "Pink Mushroom Life Is A Vibe",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-mushroom-life-is-a-vibe.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-mushroom-life-is-a-vibe.jpg")
  },
  {
    "id": "wall--pink-ribbon-bow-on-stripes",
    "name": "Pink Ribbon Bow On Stripes",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-ribbon-bow-on-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-ribbon-bow-on-stripes.jpg")
  },
  {
    "id": "wall--pink-star-cowboy-boots-good-places",
    "name": "Pink Star Cowboy Boots Good Places",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-star-cowboy-boots-good-places.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-star-cowboy-boots-good-places.jpg")
  },
  {
    "id": "wall--pink-wavy-smiley-blue-checkerboard",
    "name": "Pink Wavy Smiley Blue Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/pink-wavy-smiley-blue-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/pink-wavy-smiley-blue-checkerboard.jpg")
  },
  {
    "id": "wall--purple-metallic-heart-on-pastel-gradient",
    "name": "Purple Metallic Heart On Pastel Gradient",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/purple-metallic-heart-on-pastel-gradient.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/purple-metallic-heart-on-pastel-gradient.jpg")
  },
  {
    "id": "wall--radiate-positivity-pastel-disco-ball",
    "name": "Radiate Positivity Pastel Disco Ball",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/radiate-positivity-pastel-disco-ball.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/radiate-positivity-pastel-disco-ball.jpg")
  },
  {
    "id": "wall--red-painted-heart-on-pink",
    "name": "Red Painted Heart On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/red-painted-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/red-painted-heart-on-pink.jpg")
  },
  {
    "id": "wall--red-strawberry-on-pink",
    "name": "Red Strawberry On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/red-strawberry-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/red-strawberry-on-pink.jpg")
  },
  {
    "id": "wall--seated-woman-blue-line-art-stress-quote",
    "name": "Seated Woman Blue Line Art Stress Quote",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/seated-woman-blue-line-art-stress-quote.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/seated-woman-blue-line-art-stress-quote.jpg")
  },
  {
    "id": "wall--see-good-in-all-things-pastel",
    "name": "See Good In All Things Pastel",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/see-good-in-all-things-pastel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/see-good-in-all-things-pastel.jpg")
  },
  {
    "id": "wall--smiling-daisy-orange-checkerboard",
    "name": "Smiling Daisy Orange Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/smiling-daisy-orange-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/smiling-daisy-orange-checkerboard.jpg")
  },
  {
    "id": "wall--stay-inspired-butterfly-pastel-gradient",
    "name": "Stay Inspired Butterfly Pastel Gradient",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/stay-inspired-butterfly-pastel-gradient.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/stay-inspired-butterfly-pastel-gradient.jpg")
  },
  {
    "id": "wall--stay-positive-woman-with-flower-head",
    "name": "Stay Positive Woman With Flower Head",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/stay-positive-woman-with-flower-head.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/stay-positive-woman-with-flower-head.jpg")
  },
  {
    "id": "wall--stay-positive-yellow-sunflower",
    "name": "Stay Positive Yellow Sunflower",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/stay-positive-yellow-sunflower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/stay-positive-yellow-sunflower.jpg")
  },
  {
    "id": "wall--strawberry-cake-on-pink-gingham",
    "name": "Strawberry Cake On Pink Gingham",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/strawberry-cake-on-pink-gingham.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/strawberry-cake-on-pink-gingham.jpg")
  },
  {
    "id": "wall--sweet-purple-lips-and-pink-tongue",
    "name": "Sweet Purple Lips And Pink Tongue",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/sweet-purple-lips-and-pink-tongue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/sweet-purple-lips-and-pink-tongue.jpg")
  },
  {
    "id": "wall--sweet-time-cherry-cupcake",
    "name": "Sweet Time Cherry Cupcake",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/sweet-time-cherry-cupcake.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/sweet-time-cherry-cupcake.jpg")
  },
  {
    "id": "wall--three-hands-toasting-pink-wine-glasses",
    "name": "Three Hands Toasting Pink Wine Glasses",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/three-hands-toasting-pink-wine-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/three-hands-toasting-pink-wine-glasses.jpg")
  },
  {
    "id": "wall--three-smiling-pink-flowers-orange-checkerboard",
    "name": "Three Smiling Pink Flowers Orange Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/three-smiling-pink-flowers-orange-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/three-smiling-pink-flowers-orange-checkerboard.jpg")
  },
  {
    "id": "wall--time-to-party-three-cocktail-glasses",
    "name": "Time To Party Three Cocktail Glasses",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/time-to-party-three-cocktail-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/time-to-party-three-cocktail-glasses.jpg")
  },
  {
    "id": "wall--trust-your-intuition-yellow-aura",
    "name": "Trust Your Intuition Yellow Aura",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/trust-your-intuition-yellow-aura.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/trust-your-intuition-yellow-aura.jpg")
  },
  {
    "id": "wall--two-pink-dice-on-blush",
    "name": "Two Pink Dice On Blush",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/two-pink-dice-on-blush.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/two-pink-dice-on-blush.jpg")
  },
  {
    "id": "wall--vacation-turquoise-ocean-beach",
    "name": "Vacation Turquoise Ocean Beach",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/vacation-turquoise-ocean-beach.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/vacation-turquoise-ocean-beach.jpg")
  },
  {
    "id": "wall--watercolor-red-cherries-pink-frame",
    "name": "Watercolor Red Cherries Pink Frame",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/watercolor-red-cherries-pink-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/watercolor-red-cherries-pink-frame.jpg")
  },
  {
    "id": "wall--what-you-think-you-create-abstract-face",
    "name": "What You Think You Create Abstract Face",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/what-you-think-you-create-abstract-face.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/what-you-think-you-create-abstract-face.jpg")
  },
  {
    "id": "wall--white-wireframe-heart-on-pink",
    "name": "White Wireframe Heart On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/white-wireframe-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/white-wireframe-heart-on-pink.jpg")
  },
  {
    "id": "wall--y2k-pink-bubble-letters-and-sparkles",
    "name": "Y2k Pink Bubble Letters And Sparkles",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/y2k-pink-bubble-letters-and-sparkles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/y2k-pink-bubble-letters-and-sparkles.jpg")
  },
  {
    "id": "wall--yellow-wavy-smiley-black-checkerboard",
    "name": "Yellow Wavy Smiley Black Checkerboard",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/yellow-wavy-smiley-black-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/yellow-wavy-smiley-black-checkerboard.jpg")
  },
  {
    "id": "wall--yes-you-can-pastel-bubble-lettering",
    "name": "Yes You Can Pastel Bubble Lettering",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/yes-you-can-pastel-bubble-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/yes-you-can-pastel-bubble-lettering.jpg")
  },
  {
    "id": "wall--you-are-a-whole-universe-body-contours",
    "name": "You Are A Whole Universe Body Contours",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-are-a-whole-universe-body-contours.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-are-a-whole-universe-body-contours.jpg")
  },
  {
    "id": "wall--you-are-born-to-be-loved-glossy-heart",
    "name": "You Are Born To Be Loved Glossy Heart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-are-born-to-be-loved-glossy-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-are-born-to-be-loved-glossy-heart.jpg")
  },
  {
    "id": "wall--you-are-enough-pink-pixel-heart",
    "name": "You Are Enough Pink Pixel Heart",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-are-enough-pink-pixel-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-are-enough-pink-pixel-heart.jpg")
  },
  {
    "id": "wall--you-are-enough-yellow-flower",
    "name": "You Are Enough Yellow Flower",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-are-enough-yellow-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-are-enough-yellow-flower.jpg")
  },
  {
    "id": "wall--you-deserve-the-love-you-give",
    "name": "You Deserve The Love You Give",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-deserve-the-love-you-give.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-deserve-the-love-you-give.jpg")
  },
  {
    "id": "wall--you-glow-differently-happy-smiley",
    "name": "You Glow Differently Happy Smiley",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-glow-differently-happy-smiley.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-glow-differently-happy-smiley.jpg")
  },
  {
    "id": "wall--you-got-this-black-on-pink",
    "name": "You Got This Black On Pink",
    "category": "Eclectic Mix",
    "src": window.StrayzyAsset("./assets/background-patterns/wall/you-got-this-black-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/wall/you-got-this-black-on-pink.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-and-cream-concentric-diamonds",
    "name": "Black And Cream Concentric Diamonds",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-and-cream-concentric-diamonds.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-and-cream-concentric-diamonds.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-and-white-circles-with-checkerboard-squares",
    "name": "Black And White Circles With Checkerboard Squares",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-and-white-circles-with-checkerboard-squares.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-and-white-circles-with-checkerboard-squares.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-bold-curved-stripes-in-white-frame",
    "name": "Black Bold Curved Stripes In White Frame",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-bold-curved-stripes-in-white-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-bold-curved-stripes-in-white-frame.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-bold-squiggles-in-rectangular-frame",
    "name": "Black Bold Squiggles In Rectangular Frame",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-bold-squiggles-in-rectangular-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-bold-squiggles-in-rectangular-frame.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-concentric-arches-on-cream",
    "name": "Black Concentric Arches On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-concentric-arches-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-concentric-arches-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-concentric-circles-on-cream",
    "name": "Black Concentric Circles On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-concentric-circles-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-concentric-circles-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-curved-ribbon-lines-on-cream",
    "name": "Black Curved Ribbon Lines On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-curved-ribbon-lines-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-curved-ribbon-lines-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-flowing-stripes-in-rounded-rectangle",
    "name": "Black Flowing Stripes In Rounded Rectangle",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-flowing-stripes-in-rounded-rectangle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-flowing-stripes-in-rounded-rectangle.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-flowing-zebra-stripe-pattern-on-cream",
    "name": "Black Flowing Zebra Stripe Pattern On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-flowing-zebra-stripe-pattern-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-flowing-zebra-stripe-pattern-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-interlocking-curved-stripe-bands-on-cream",
    "name": "Black Interlocking Curved Stripe Bands On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-interlocking-curved-stripe-bands-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-interlocking-curved-stripe-bands-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-nested-cross-shaped-contours-on-cream",
    "name": "Black Nested Cross Shaped Contours On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-nested-cross-shaped-contours-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-nested-cross-shaped-contours-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-nested-organic-curves-on-cream",
    "name": "Black Nested Organic Curves On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-nested-organic-curves-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-nested-organic-curves-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-opposing-arches-with-central-circle",
    "name": "Black Opposing Arches With Central Circle",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-opposing-arches-with-central-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-opposing-arches-with-central-circle.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-organic-wavy-lines-on-cream",
    "name": "Black Organic Wavy Lines On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-organic-wavy-lines-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-organic-wavy-lines-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-oval-grid-optical-illusion-on-cream",
    "name": "Black Oval Grid Optical Illusion On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-oval-grid-optical-illusion-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-oval-grid-optical-illusion-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-overlapping-wavy-loops-on-cream",
    "name": "Black Overlapping Wavy Loops On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-overlapping-wavy-loops-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-overlapping-wavy-loops-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-quarter-circle-lines-in-opposite-corners",
    "name": "Black Quarter Circle Lines In Opposite Corners",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-quarter-circle-lines-in-opposite-corners.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-quarter-circle-lines-in-opposite-corners.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-radial-line-sunburst-on-cream",
    "name": "Black Radial Line Sunburst On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-radial-line-sunburst-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-radial-line-sunburst-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-rounded-square-spiral-on-cream",
    "name": "Black Rounded Square Spiral On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-rounded-square-spiral-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-rounded-square-spiral-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-s-curved-lines-with-two-circles",
    "name": "Black S Curved Lines With Two Circles",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-s-curved-lines-with-two-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-s-curved-lines-with-two-circles.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-swirling-zebra-stripes-in-rectangular-frame",
    "name": "Black Swirling Zebra Stripes In Rectangular Frame",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-swirling-zebra-stripes-in-rectangular-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-swirling-zebra-stripes-in-rectangular-frame.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-topographic-contour-pattern-on-cream",
    "name": "Black Topographic Contour Pattern On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-topographic-contour-pattern-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-topographic-contour-pattern-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-twisted-fine-line-ribbon-on-cream",
    "name": "Black Twisted Fine Line Ribbon On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-twisted-fine-line-ribbon-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-twisted-fine-line-ribbon-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-warped-stripes-in-rectangular-frame",
    "name": "Black Warped Stripes In Rectangular Frame",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-warped-stripes-in-rectangular-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-warped-stripes-in-rectangular-frame.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-wavy-spiral-in-square-frame",
    "name": "Black Wavy Spiral In Square Frame",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-wavy-spiral-in-square-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-wavy-spiral-in-square-frame.jpg")
  },
  {
    "id": "abstract-geometric-line-art--black-winding-parallel-ribbon-on-cream",
    "name": "Black Winding Parallel Ribbon On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/black-winding-parallel-ribbon-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/black-winding-parallel-ribbon-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--small-black-polka-dot-grid-on-cream",
    "name": "Small Black Polka Dot Grid On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/small-black-polka-dot-grid-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/small-black-polka-dot-grid-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--three-white-nested-arches-on-black",
    "name": "Three White Nested Arches On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/three-white-nested-arches-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/three-white-nested-arches-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--two-black-rounded-squiggles-on-cream",
    "name": "Two Black Rounded Squiggles On Cream",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/two-black-rounded-squiggles-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/two-black-rounded-squiggles-on-cream.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-arch-with-circle-on-black",
    "name": "White Arch With Circle On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-arch-with-circle-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-arch-with-circle-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-circle-grid-in-black-square",
    "name": "White Circle Grid In Black Square",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-circle-grid-in-black-square.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-circle-grid-in-black-square.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-circle-with-curved-corner-lines-on-black",
    "name": "White Circle With Curved Corner Lines On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-circle-with-curved-corner-lines-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-circle-with-curved-corner-lines-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-concentric-capsule-outlines-on-black",
    "name": "White Concentric Capsule Outlines On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-concentric-capsule-outlines-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-concentric-capsule-outlines-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-flowing-parallel-waves-on-black",
    "name": "White Flowing Parallel Waves On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-flowing-parallel-waves-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-flowing-parallel-waves-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-interlocking-rounded-angular-loops-on-black",
    "name": "White Interlocking Rounded Angular Loops On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-interlocking-rounded-angular-loops-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-interlocking-rounded-angular-loops-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-intersecting-flowing-curves-on-black",
    "name": "White Intersecting Flowing Curves On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-intersecting-flowing-curves-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-intersecting-flowing-curves-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-nested-bean-shaped-contours-on-black",
    "name": "White Nested Bean Shaped Contours On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-nested-bean-shaped-contours-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-nested-bean-shaped-contours-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-opposing-semicircles-with-three-dots",
    "name": "White Opposing Semicircles With Three Dots",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-opposing-semicircles-with-three-dots.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-opposing-semicircles-with-three-dots.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-organic-contour-lines-in-rectangular-panel",
    "name": "White Organic Contour Lines In Rectangular Panel",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-organic-contour-lines-in-rectangular-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-organic-contour-lines-in-rectangular-panel.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-overlapping-angular-loops-on-black",
    "name": "White Overlapping Angular Loops On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-overlapping-angular-loops-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-overlapping-angular-loops-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-repeating-semicircle-grid-on-black",
    "name": "White Repeating Semicircle Grid On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-repeating-semicircle-grid-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-repeating-semicircle-grid-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-s-shaped-semicircle-lines-on-black",
    "name": "White S Shaped Semicircle Lines On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-s-shaped-semicircle-lines-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-s-shaped-semicircle-lines-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-spaced-polka-dot-grid-on-black",
    "name": "White Spaced Polka Dot Grid On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-spaced-polka-dot-grid-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-spaced-polka-dot-grid-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-split-circle-with-semicircular-lines",
    "name": "White Split Circle With Semicircular Lines",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-split-circle-with-semicircular-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-split-circle-with-semicircular-lines.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-stacked-semicircles-on-black",
    "name": "White Stacked Semicircles On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-stacked-semicircles-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-stacked-semicircles-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-tapered-spiral-on-black",
    "name": "White Tapered Spiral On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-tapered-spiral-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-tapered-spiral-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-twisting-parallel-wave-ribbon-on-black",
    "name": "White Twisting Parallel Wave Ribbon On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-twisting-parallel-wave-ribbon-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-twisting-parallel-wave-ribbon-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-u-shaped-lines-with-two-circles",
    "name": "White U Shaped Lines With Two Circles",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-u-shaped-lines-with-two-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-u-shaped-lines-with-two-circles.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-vertically-overlapping-circles-on-black",
    "name": "White Vertically Overlapping Circles On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-vertically-overlapping-circles-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-vertically-overlapping-circles-on-black.jpg")
  },
  {
    "id": "abstract-geometric-line-art--white-warped-contour-lines-on-black",
    "name": "White Warped Contour Lines On Black",
    "category": "Abstract Geometric Line Art",
    "src": window.StrayzyAsset("./assets/background-patterns/abstract-geometric-line-art/white-warped-contour-lines-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/abstract-geometric-line-art/white-warped-contour-lines-on-black.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-crescent-moon-and-circle",
    "name": "Bauhaus Black Crescent Moon And Circle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-crescent-moon-and-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-crescent-moon-and-circle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-curved-diamond-in-blue-square",
    "name": "Bauhaus Black Curved Diamond In Blue Square",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-curved-diamond-in-blue-square.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-curved-diamond-in-blue-square.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-curved-parallel-lines-on-blue",
    "name": "Bauhaus Black Curved Parallel Lines On Blue",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-curved-parallel-lines-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-curved-parallel-lines-on-blue.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-eye-in-cream-circle",
    "name": "Bauhaus Black Eye In Cream Circle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-eye-in-cream-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-eye-in-cream-circle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-eye-with-pink-concentric-pupil",
    "name": "Bauhaus Black Eye With Pink Concentric Pupil",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-eye-with-pink-concentric-pupil.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-eye-with-pink-concentric-pupil.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-four-blade-pinwheel",
    "name": "Bauhaus Black Four Blade Pinwheel",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-four-blade-pinwheel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-four-blade-pinwheel.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-geometric-shape-mosaic",
    "name": "Bauhaus Black Geometric Shape Mosaic",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-geometric-shape-mosaic.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-geometric-shape-mosaic.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-half-solid-half-striped-circle",
    "name": "Bauhaus Black Half Solid Half Striped Circle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-half-solid-half-striped-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-half-solid-half-striped-circle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-radial-sunburst-on-pink",
    "name": "Bauhaus Black Radial Sunburst On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-radial-sunburst-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-radial-sunburst-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-ring-overlapping-cream-circle",
    "name": "Bauhaus Black Ring Overlapping Cream Circle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-ring-overlapping-cream-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-ring-overlapping-cream-circle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-s-curve-lines-and-two-dots",
    "name": "Bauhaus Black S Curve Lines And Two Dots",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-s-curve-lines-and-two-dots.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-s-curve-lines-and-two-dots.jpg")
  },
  {
    "id": "bauhaus--bauhaus-black-semicircle-burgundy-dot-on-pink",
    "name": "Bauhaus Black Semicircle Burgundy Dot On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-black-semicircle-burgundy-dot-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-black-semicircle-burgundy-dot-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-and-black-connected-circles",
    "name": "Bauhaus Burgundy And Black Connected Circles",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-and-black-connected-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-and-black-connected-circles.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-and-black-stacked-triangles",
    "name": "Bauhaus Burgundy And Black Stacked Triangles",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-and-black-stacked-triangles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-and-black-stacked-triangles.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-and-blue-quarter-circles",
    "name": "Bauhaus Burgundy And Blue Quarter Circles",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-and-blue-quarter-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-and-blue-quarter-circles.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-circle-grid-with-lavender-dot",
    "name": "Bauhaus Burgundy Circle Grid With Lavender Dot",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-circle-grid-with-lavender-dot.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-circle-grid-with-lavender-dot.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-four-point-star-on-pink",
    "name": "Bauhaus Burgundy Four Point Star On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-four-point-star-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-four-point-star-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-hourglass-and-two-dots",
    "name": "Bauhaus Burgundy Hourglass And Two Dots",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-hourglass-and-two-dots.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-hourglass-and-two-dots.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-pink-stacked-rectangles-and-circles",
    "name": "Bauhaus Burgundy Pink Stacked Rectangles And Circles",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-pink-stacked-rectangles-and-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-pink-stacked-rectangles-and-circles.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-pointed-starburst-on-pink",
    "name": "Bauhaus Burgundy Pointed Starburst On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-pointed-starburst-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-pointed-starburst-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-ring-cream-center-on-pink",
    "name": "Bauhaus Burgundy Ring Cream Center On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-ring-cream-center-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-ring-cream-center-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-semicircle-black-concentric-arcs",
    "name": "Bauhaus Burgundy Semicircle Black Concentric Arcs",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-semicircle-black-concentric-arcs.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-semicircle-black-concentric-arcs.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-triangular-patchwork-on-pink",
    "name": "Bauhaus Burgundy Triangular Patchwork On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-triangular-patchwork-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-triangular-patchwork-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-vertical-striped-circle",
    "name": "Bauhaus Burgundy Vertical Striped Circle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-vertical-striped-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-vertical-striped-circle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-burgundy-winding-line-ribbon-on-blue",
    "name": "Bauhaus Burgundy Winding Line Ribbon On Blue",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-burgundy-winding-line-ribbon-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-burgundy-winding-line-ribbon-on-blue.jpg")
  },
  {
    "id": "bauhaus--bauhaus-cream-concentric-circles-on-lavender",
    "name": "Bauhaus Cream Concentric Circles On Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-cream-concentric-circles-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-cream-concentric-circles-on-lavender.jpg")
  },
  {
    "id": "bauhaus--bauhaus-cream-radial-sunburst-on-lavender",
    "name": "Bauhaus Cream Radial Sunburst On Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-cream-radial-sunburst-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-cream-radial-sunburst-on-lavender.jpg")
  },
  {
    "id": "bauhaus--bauhaus-five-black-checkerboard-squares-on-pink",
    "name": "Bauhaus Five Black Checkerboard Squares On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-five-black-checkerboard-squares-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-five-black-checkerboard-squares-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-black-and-lavender-circles",
    "name": "Bauhaus Four Black And Lavender Circles",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-black-and-lavender-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-black-and-lavender-circles.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-black-pointed-oval-leaves",
    "name": "Bauhaus Four Black Pointed Oval Leaves",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-black-pointed-oval-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-black-pointed-oval-leaves.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-blue-rings-on-lavender",
    "name": "Bauhaus Four Blue Rings On Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-blue-rings-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-blue-rings-on-lavender.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-burgundy-diamonds-on-pink",
    "name": "Bauhaus Four Burgundy Diamonds On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-burgundy-diamonds-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-burgundy-diamonds-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-cream-quarter-circles-on-lavender",
    "name": "Bauhaus Four Cream Quarter Circles On Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-cream-quarter-circles-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-cream-quarter-circles-on-lavender.jpg")
  },
  {
    "id": "bauhaus--bauhaus-four-pink-slanted-parallelograms",
    "name": "Bauhaus Four Pink Slanted Parallelograms",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-four-pink-slanted-parallelograms.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-four-pink-slanted-parallelograms.jpg")
  },
  {
    "id": "bauhaus--bauhaus-lavender-diagonal-squiggle-on-blue",
    "name": "Bauhaus Lavender Diagonal Squiggle On Blue",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-lavender-diagonal-squiggle-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-lavender-diagonal-squiggle-on-blue.jpg")
  },
  {
    "id": "bauhaus--bauhaus-lavender-four-arm-rounded-cross",
    "name": "Bauhaus Lavender Four Arm Rounded Cross",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-lavender-four-arm-rounded-cross.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-lavender-four-arm-rounded-cross.jpg")
  },
  {
    "id": "bauhaus--bauhaus-lavender-four-petal-flower-on-blue",
    "name": "Bauhaus Lavender Four Petal Flower On Blue",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-lavender-four-petal-flower-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-lavender-four-petal-flower-on-blue.jpg")
  },
  {
    "id": "bauhaus--bauhaus-lavender-semicircle-balanced-on-triangle",
    "name": "Bauhaus Lavender Semicircle Balanced On Triangle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-lavender-semicircle-balanced-on-triangle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-lavender-semicircle-balanced-on-triangle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pale-blue-eight-petal-flower",
    "name": "Bauhaus Pale Blue Eight Petal Flower",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pale-blue-eight-petal-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pale-blue-eight-petal-flower.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pastel-concentric-rings-in-burgundy-square",
    "name": "Bauhaus Pastel Concentric Rings In Burgundy Square",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pastel-concentric-rings-in-burgundy-square.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pastel-concentric-rings-in-burgundy-square.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pink-circle-balanced-on-semicircle",
    "name": "Bauhaus Pink Circle Balanced On Semicircle",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pink-circle-balanced-on-semicircle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pink-circle-balanced-on-semicircle.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pink-eye-over-burgundy-stripes",
    "name": "Bauhaus Pink Eye Over Burgundy Stripes",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pink-eye-over-burgundy-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pink-eye-over-burgundy-stripes.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pink-four-point-star-lavender-petals",
    "name": "Bauhaus Pink Four Point Star Lavender Petals",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pink-four-point-star-lavender-petals.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pink-four-point-star-lavender-petals.jpg")
  },
  {
    "id": "bauhaus--bauhaus-pink-rounded-leaf-burgundy-outline",
    "name": "Bauhaus Pink Rounded Leaf Burgundy Outline",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-pink-rounded-leaf-burgundy-outline.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-pink-rounded-leaf-burgundy-outline.jpg")
  },
  {
    "id": "bauhaus--bauhaus-split-pastel-circle-on-burgundy-and-lavender",
    "name": "Bauhaus Split Pastel Circle On Burgundy And Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-split-pastel-circle-on-burgundy-and-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-split-pastel-circle-on-burgundy-and-lavender.jpg")
  },
  {
    "id": "bauhaus--bauhaus-three-cream-semicircles-on-burgundy",
    "name": "Bauhaus Three Cream Semicircles On Burgundy",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-three-cream-semicircles-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-three-cream-semicircles-on-burgundy.jpg")
  },
  {
    "id": "bauhaus--bauhaus-two-blue-opposing-semicircles-on-pink",
    "name": "Bauhaus Two Blue Opposing Semicircles On Pink",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-two-blue-opposing-semicircles-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-two-blue-opposing-semicircles-on-pink.jpg")
  },
  {
    "id": "bauhaus--bauhaus-two-burgundy-stacked-half-rings",
    "name": "Bauhaus Two Burgundy Stacked Half Rings",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-two-burgundy-stacked-half-rings.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-two-burgundy-stacked-half-rings.jpg")
  },
  {
    "id": "bauhaus--bauhaus-two-opposing-burgundy-half-rings",
    "name": "Bauhaus Two Opposing Burgundy Half Rings",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-two-opposing-burgundy-half-rings.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-two-opposing-burgundy-half-rings.jpg")
  },
  {
    "id": "bauhaus--bauhaus-two-pale-blue-semicircles-on-lavender",
    "name": "Bauhaus Two Pale Blue Semicircles On Lavender",
    "category": "Bauhaus",
    "src": window.StrayzyAsset("./assets/background-patterns/bauhaus/bauhaus-two-pale-blue-semicircles-on-lavender.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/bauhaus/bauhaus-two-pale-blue-semicircles-on-lavender.jpg")
  },
  {
    "id": "black-white--bad-boy-black-brush-lettering",
    "name": "Bad Boy Black Brush Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/bad-boy-black-brush-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/bad-boy-black-brush-lettering.jpg")
  },
  {
    "id": "black-white--black-and-white-marbled-swirls",
    "name": "Black And White Marbled Swirls",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-and-white-marbled-swirls.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-and-white-marbled-swirls.jpg")
  },
  {
    "id": "black-white--black-and-white-square-checkerboard",
    "name": "Black And White Square Checkerboard",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-and-white-square-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-and-white-square-checkerboard.jpg")
  },
  {
    "id": "black-white--black-and-white-zebra-stripes",
    "name": "Black And White Zebra Stripes",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-and-white-zebra-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-and-white-zebra-stripes.jpg")
  },
  {
    "id": "black-white--black-billiard-eight-ball",
    "name": "Black Billiard Eight Ball",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-billiard-eight-ball.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-billiard-eight-ball.jpg")
  },
  {
    "id": "black-white--black-cherries-with-ribbon-bow",
    "name": "Black Cherries With Ribbon Bow",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-cherries-with-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-cherries-with-ribbon-bow.jpg")
  },
  {
    "id": "black-white--black-leopard-spot-pattern",
    "name": "Black Leopard Spot Pattern",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-leopard-spot-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-leopard-spot-pattern.jpg")
  },
  {
    "id": "black-white--black-skeleton-hand-rock-gesture",
    "name": "Black Skeleton Hand Rock Gesture",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-skeleton-hand-rock-gesture.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-skeleton-hand-rock-gesture.jpg")
  },
  {
    "id": "black-white--black-warped-wire-grid",
    "name": "Black Warped Wire Grid",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-warped-wire-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-warped-wire-grid.jpg")
  },
  {
    "id": "black-white--black-wavy-smiley-face",
    "name": "Black Wavy Smiley Face",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/black-wavy-smiley-face.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/black-wavy-smiley-face.jpg")
  },
  {
    "id": "black-white--blah-blah-blah-white-circular-lettering",
    "name": "Blah Blah Blah White Circular Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/blah-blah-blah-white-circular-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/blah-blah-blah-white-circular-lettering.jpg")
  },
  {
    "id": "black-white--checkerboard-star-outline-on-black",
    "name": "Checkerboard Star Outline On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/checkerboard-star-outline-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/checkerboard-star-outline-on-black.jpg")
  },
  {
    "id": "black-white--clear-gummy-bear-on-black",
    "name": "Clear Gummy Bear On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/clear-gummy-bear-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/clear-gummy-bear-on-black.jpg")
  },
  {
    "id": "black-white--cocktail-coupe-with-black-bow",
    "name": "Cocktail Coupe With Black Bow",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/cocktail-coupe-with-black-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/cocktail-coupe-with-black-bow.jpg")
  },
  {
    "id": "black-white--enjoy-life-white-script",
    "name": "Enjoy Life White Script",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/enjoy-life-white-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/enjoy-life-white-script.jpg")
  },
  {
    "id": "black-white--find-peace-of-mind-nested-heads",
    "name": "Find Peace Of Mind Nested Heads",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/find-peace-of-mind-nested-heads.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/find-peace-of-mind-nested-heads.jpg")
  },
  {
    "id": "black-white--five-white-hand-drawn-hearts",
    "name": "Five White Hand Drawn Hearts",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/five-white-hand-drawn-hearts.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/five-white-hand-drawn-hearts.jpg")
  },
  {
    "id": "black-white--four-dancing-white-skeletons",
    "name": "Four Dancing White Skeletons",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/four-dancing-white-skeletons.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/four-dancing-white-skeletons.jpg")
  },
  {
    "id": "black-white--good-things-take-time-white-script",
    "name": "Good Things Take Time White Script",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/good-things-take-time-white-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/good-things-take-time-white-script.jpg")
  },
  {
    "id": "black-white--ha-ha-ha-white-bubble-lettering",
    "name": "Ha Ha Ha White Bubble Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/ha-ha-ha-white-bubble-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/ha-ha-ha-white-bubble-lettering.jpg")
  },
  {
    "id": "black-white--heart-tic-tac-toe-line-art",
    "name": "Heart Tic Tac Toe Line Art",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/heart-tic-tac-toe-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/heart-tic-tac-toe-line-art.jpg")
  },
  {
    "id": "black-white--love-lettering-in-black-heart",
    "name": "Love Lettering In Black Heart",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/love-lettering-in-black-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/love-lettering-in-black-heart.jpg")
  },
  {
    "id": "black-white--love-yourself-black-lettering",
    "name": "Love Yourself Black Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/love-yourself-black-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/love-yourself-black-lettering.jpg")
  },
  {
    "id": "black-white--nice-two-inverted-smiley-faces",
    "name": "Nice Two Inverted Smiley Faces",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/nice-two-inverted-smiley-faces.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/nice-two-inverted-smiley-faces.jpg")
  },
  {
    "id": "black-white--omg-repeated-white-bubble-lettering",
    "name": "Omg Repeated White Bubble Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/omg-repeated-white-bubble-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/omg-repeated-white-bubble-lettering.jpg")
  },
  {
    "id": "black-white--open-mind-black-circular-lettering",
    "name": "Open Mind Black Circular Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/open-mind-black-circular-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/open-mind-black-circular-lettering.jpg")
  },
  {
    "id": "black-white--rave-vibe-melting-smiley-pattern",
    "name": "Rave Vibe Melting Smiley Pattern",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/rave-vibe-melting-smiley-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/rave-vibe-melting-smiley-pattern.jpg")
  },
  {
    "id": "black-white--self-care-white-candy-heart",
    "name": "Self Care White Candy Heart",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/self-care-white-candy-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/self-care-white-candy-heart.jpg")
  },
  {
    "id": "black-white--silver-alien-head-on-black",
    "name": "Silver Alien Head On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/silver-alien-head-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/silver-alien-head-on-black.jpg")
  },
  {
    "id": "black-white--silver-disco-ball-on-black",
    "name": "Silver Disco Ball On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/silver-disco-ball-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/silver-disco-ball-on-black.jpg")
  },
  {
    "id": "black-white--silver-inflated-star-on-black",
    "name": "Silver Inflated Star On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/silver-inflated-star-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/silver-inflated-star-on-black.jpg")
  },
  {
    "id": "black-white--silver-metallic-love-letters",
    "name": "Silver Metallic Love Letters",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/silver-metallic-love-letters.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/silver-metallic-love-letters.jpg")
  },
  {
    "id": "black-white--start-over-black-brush-lettering",
    "name": "Start Over Black Brush Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/start-over-black-brush-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/start-over-black-brush-lettering.jpg")
  },
  {
    "id": "black-white--take-a-break-white-lettering",
    "name": "Take A Break White Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/take-a-break-white-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/take-a-break-white-lettering.jpg")
  },
  {
    "id": "black-white--take-time-for-yourself-black-lettering",
    "name": "Take Time For Yourself Black Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/take-time-for-yourself-black-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/take-time-for-yourself-black-lettering.jpg")
  },
  {
    "id": "black-white--three-black-faceted-stars",
    "name": "Three Black Faceted Stars",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/three-black-faceted-stars.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/three-black-faceted-stars.jpg")
  },
  {
    "id": "black-white--three-tier-decorated-cake-line-art",
    "name": "Three Tier Decorated Cake Line Art",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/three-tier-decorated-cake-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/three-tier-decorated-cake-line-art.jpg")
  },
  {
    "id": "black-white--three-white-detailed-butterflies-on-black",
    "name": "Three White Detailed Butterflies On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/three-white-detailed-butterflies-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/three-white-detailed-butterflies-on-black.jpg")
  },
  {
    "id": "black-white--two-black-and-white-dice",
    "name": "Two Black And White Dice",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/two-black-and-white-dice.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/two-black-and-white-dice.jpg")
  },
  {
    "id": "black-white--warped-black-and-white-checkerboard",
    "name": "Warped Black And White Checkerboard",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/warped-black-and-white-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/warped-black-and-white-checkerboard.jpg")
  },
  {
    "id": "black-white--warped-black-oval-grid",
    "name": "Warped Black Oval Grid",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/warped-black-oval-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/warped-black-oval-grid.jpg")
  },
  {
    "id": "black-white--white-butterfly-silhouette-pattern-on-black",
    "name": "White Butterfly Silhouette Pattern On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/white-butterfly-silhouette-pattern-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/white-butterfly-silhouette-pattern-on-black.jpg")
  },
  {
    "id": "black-white--white-elongated-heart-on-black",
    "name": "White Elongated Heart On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/white-elongated-heart-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/white-elongated-heart-on-black.jpg")
  },
  {
    "id": "black-white--white-four-point-sparkles-on-black",
    "name": "White Four Point Sparkles On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/white-four-point-sparkles-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/white-four-point-sparkles-on-black.jpg")
  },
  {
    "id": "black-white--white-long-ribbon-bow-on-black",
    "name": "White Long Ribbon Bow On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/white-long-ribbon-bow-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/white-long-ribbon-bow-on-black.jpg")
  },
  {
    "id": "black-white--white-smiley-face-on-black",
    "name": "White Smiley Face On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/white-smiley-face-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/white-smiley-face-on-black.jpg")
  },
  {
    "id": "black-white--xoxo-white-lettering-on-black",
    "name": "Xoxo White Lettering On Black",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/xoxo-white-lettering-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/xoxo-white-lettering-on-black.jpg")
  },
  {
    "id": "black-white--yeah-black-bubble-lettering",
    "name": "Yeah Black Bubble Lettering",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/yeah-black-bubble-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/yeah-black-bubble-lettering.jpg")
  },
  {
    "id": "black-white--yes-you-can-black-script",
    "name": "Yes You Can Black Script",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/yes-you-can-black-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/yes-you-can-black-script.jpg")
  },
  {
    "id": "black-white--you-got-this-white-script",
    "name": "You Got This White Script",
    "category": "Black White",
    "src": window.StrayzyAsset("./assets/background-patterns/black-white/you-got-this-white-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/black-white/you-got-this-white-script.jpg")
  },
  {
    "id": "blue--1111-the-universe-is-listening-blue",
    "name": "1111 The Universe Is Listening Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/1111-the-universe-is-listening-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/1111-the-universe-is-listening-blue.jpg")
  },
  {
    "id": "blue--abstract-blue-flowers-and-leaves",
    "name": "Abstract Blue Flowers And Leaves",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/abstract-blue-flowers-and-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/abstract-blue-flowers-and-leaves.jpg")
  },
  {
    "id": "blue--black-anatomical-heart-on-pale-blue",
    "name": "Black Anatomical Heart On Pale Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/black-anatomical-heart-on-pale-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/black-anatomical-heart-on-pale-blue.jpg")
  },
  {
    "id": "blue--black-eyelash-eye-pattern-on-blue",
    "name": "Black Eyelash Eye Pattern On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/black-eyelash-eye-pattern-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/black-eyelash-eye-pattern-on-blue.jpg")
  },
  {
    "id": "blue--black-love-lettering-pattern-on-blue",
    "name": "Black Love Lettering Pattern On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/black-love-lettering-pattern-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/black-love-lettering-pattern-on-blue.jpg")
  },
  {
    "id": "blue--black-vinyl-record-on-pale-blue",
    "name": "Black Vinyl Record On Pale Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/black-vinyl-record-on-pale-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/black-vinyl-record-on-pale-blue.jpg")
  },
  {
    "id": "blue--blue-conch-shell-line-art",
    "name": "Blue Conch Shell Line Art",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-conch-shell-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-conch-shell-line-art.jpg")
  },
  {
    "id": "blue--blue-crystal-scallop-shell",
    "name": "Blue Crystal Scallop Shell",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-crystal-scallop-shell.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-crystal-scallop-shell.jpg")
  },
  {
    "id": "blue--blue-evil-eye-amulet",
    "name": "Blue Evil Eye Amulet",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-evil-eye-amulet.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-evil-eye-amulet.jpg")
  },
  {
    "id": "blue--blue-flower-in-white-panel",
    "name": "Blue Flower In White Panel",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-flower-in-white-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-flower-in-white-panel.jpg")
  },
  {
    "id": "blue--blue-flowing-fern-leaves",
    "name": "Blue Flowing Fern Leaves",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-flowing-fern-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-flowing-fern-leaves.jpg")
  },
  {
    "id": "blue--blue-jellyfish-line-art",
    "name": "Blue Jellyfish Line Art",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-jellyfish-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-jellyfish-line-art.jpg")
  },
  {
    "id": "blue--blue-satin-ribbon-bow",
    "name": "Blue Satin Ribbon Bow",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-satin-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-satin-ribbon-bow.jpg")
  },
  {
    "id": "blue--blue-spiral-seashell",
    "name": "Blue Spiral Seashell",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-spiral-seashell.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-spiral-seashell.jpg")
  },
  {
    "id": "blue--blue-thick-looping-squiggle",
    "name": "Blue Thick Looping Squiggle",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-thick-looping-squiggle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-thick-looping-squiggle.jpg")
  },
  {
    "id": "blue--blue-zebra-stripe-pattern",
    "name": "Blue Zebra Stripe Pattern",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/blue-zebra-stripe-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/blue-zebra-stripe-pattern.jpg")
  },
  {
    "id": "blue--cropped-blue-billiard-eight-ball",
    "name": "Cropped Blue Billiard Eight Ball",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/cropped-blue-billiard-eight-ball.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/cropped-blue-billiard-eight-ball.jpg")
  },
  {
    "id": "blue--dark-blue-organic-spiral",
    "name": "Dark Blue Organic Spiral",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/dark-blue-organic-spiral.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/dark-blue-organic-spiral.jpg")
  },
  {
    "id": "blue--do-it-for-you-white-on-blue",
    "name": "Do It For You White On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/do-it-for-you-white-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/do-it-for-you-white-on-blue.jpg")
  },
  {
    "id": "blue--dont-stop-white-script-on-blue",
    "name": "Dont Stop White Script On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/dont-stop-white-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/dont-stop-white-script-on-blue.jpg")
  },
  {
    "id": "blue--flaming-black-eight-ball-on-blue",
    "name": "Flaming Black Eight Ball On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/flaming-black-eight-ball-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/flaming-black-eight-ball-on-blue.jpg")
  },
  {
    "id": "blue--full-moon-on-cobalt-blue",
    "name": "Full Moon On Cobalt Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/full-moon-on-cobalt-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/full-moon-on-cobalt-blue.jpg")
  },
  {
    "id": "blue--keep-going-white-on-cobalt",
    "name": "Keep Going White On Cobalt",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/keep-going-white-on-cobalt.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/keep-going-white-on-cobalt.jpg")
  },
  {
    "id": "blue--life-goes-on-black-script-on-blue",
    "name": "Life Goes On Black Script On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/life-goes-on-black-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/life-goes-on-black-script-on-blue.jpg")
  },
  {
    "id": "blue--love-white-outlined-block-letters-on-blue",
    "name": "Love White Outlined Block Letters On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/love-white-outlined-block-letters-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/love-white-outlined-block-letters-on-blue.jpg")
  },
  {
    "id": "blue--love-you-white-handwritten-doodles",
    "name": "Love You White Handwritten Doodles",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/love-you-white-handwritten-doodles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/love-you-white-handwritten-doodles.jpg")
  },
  {
    "id": "blue--love-yourself-white-script-on-blue",
    "name": "Love Yourself White Script On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/love-yourself-white-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/love-yourself-white-script-on-blue.jpg")
  },
  {
    "id": "blue--lucky-mirrored-white-lettering-on-blue",
    "name": "Lucky Mirrored White Lettering On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/lucky-mirrored-white-lettering-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/lucky-mirrored-white-lettering-on-blue.jpg")
  },
  {
    "id": "blue--music-on-world-off-blue-cassette",
    "name": "Music On World Off Blue Cassette",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/music-on-world-off-blue-cassette.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/music-on-world-off-blue-cassette.jpg")
  },
  {
    "id": "blue--no-limits-white-butterfly-on-blue",
    "name": "No Limits White Butterfly On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/no-limits-white-butterfly-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/no-limits-white-butterfly-on-blue.jpg")
  },
  {
    "id": "blue--pale-blue-daisy-bouquet",
    "name": "Pale Blue Daisy Bouquet",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/pale-blue-daisy-bouquet.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/pale-blue-daisy-bouquet.jpg")
  },
  {
    "id": "blue--pale-blue-textured-star",
    "name": "Pale Blue Textured Star",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/pale-blue-textured-star.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/pale-blue-textured-star.jpg")
  },
  {
    "id": "blue--positive-affirmations-on-pale-blue",
    "name": "Positive Affirmations On Pale Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/positive-affirmations-on-pale-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/positive-affirmations-on-pale-blue.jpg")
  },
  {
    "id": "blue--silver-disco-ball-on-cobalt-blue",
    "name": "Silver Disco Ball On Cobalt Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/silver-disco-ball-on-cobalt-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/silver-disco-ball-on-cobalt-blue.jpg")
  },
  {
    "id": "blue--smile-blue-smiley-face",
    "name": "Smile Blue Smiley Face",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/smile-blue-smiley-face.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/smile-blue-smiley-face.jpg")
  },
  {
    "id": "blue--stay-focused-blue-eye",
    "name": "Stay Focused Blue Eye",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/stay-focused-blue-eye.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/stay-focused-blue-eye.jpg")
  },
  {
    "id": "blue--this-is-my-era-black-script",
    "name": "This Is My Era Black Script",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/this-is-my-era-black-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/this-is-my-era-black-script.jpg")
  },
  {
    "id": "blue--this-will-pass-blue-lettering",
    "name": "This Will Pass Blue Lettering",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/this-will-pass-blue-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/this-will-pass-blue-lettering.jpg")
  },
  {
    "id": "blue--three-blue-gingham-butterflies",
    "name": "Three Blue Gingham Butterflies",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/three-blue-gingham-butterflies.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/three-blue-gingham-butterflies.jpg")
  },
  {
    "id": "blue--three-pale-blue-daisies",
    "name": "Three Pale Blue Daisies",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/three-pale-blue-daisies.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/three-pale-blue-daisies.jpg")
  },
  {
    "id": "blue--two-black-lips-on-pale-blue",
    "name": "Two Black Lips On Pale Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/two-black-lips-on-pale-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/two-black-lips-on-pale-blue.jpg")
  },
  {
    "id": "blue--two-white-outline-dice-on-blue",
    "name": "Two White Outline Dice On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/two-white-outline-dice-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/two-white-outline-dice-on-blue.jpg")
  },
  {
    "id": "blue--white-abstract-face-line-art-on-blue",
    "name": "White Abstract Face Line Art On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/white-abstract-face-line-art-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/white-abstract-face-line-art-on-blue.jpg")
  },
  {
    "id": "blue--white-bikini-torso-line-art-on-blue",
    "name": "White Bikini Torso Line Art On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/white-bikini-torso-line-art-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/white-bikini-torso-line-art-on-blue.jpg")
  },
  {
    "id": "blue--white-cocktail-glass-with-bow-on-blue",
    "name": "White Cocktail Glass With Bow On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/white-cocktail-glass-with-bow-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/white-cocktail-glass-with-bow-on-blue.jpg")
  },
  {
    "id": "blue--white-scallop-shell-on-blue",
    "name": "White Scallop Shell On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/white-scallop-shell-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/white-scallop-shell-on-blue.jpg")
  },
  {
    "id": "blue--white-seated-figure-on-blue",
    "name": "White Seated Figure On Blue",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/white-seated-figure-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/white-seated-figure-on-blue.jpg")
  },
  {
    "id": "blue--yes-girl-you-can-blue-lettering",
    "name": "Yes Girl You Can Blue Lettering",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/yes-girl-you-can-blue-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/yes-girl-you-can-blue-lettering.jpg")
  },
  {
    "id": "blue--you-dont-chase-you-attract-white-botanical",
    "name": "You Dont Chase You Attract White Botanical",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/you-dont-chase-you-attract-white-botanical.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/you-dont-chase-you-attract-white-botanical.jpg")
  },
  {
    "id": "blue--zebra-striped-star-with-blue-border",
    "name": "Zebra Striped Star With Blue Border",
    "category": "Blue",
    "src": window.StrayzyAsset("./assets/background-patterns/blue/zebra-striped-star-with-blue-border.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/blue/zebra-striped-star-with-blue-border.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--banana-slices-on-pink",
    "name": "Banana Slices On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/banana-slices-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/banana-slices-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--citrus-cocktail-on-orange-yellow-stripes",
    "name": "Citrus Cocktail On Orange Yellow Stripes",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/citrus-cocktail-on-orange-yellow-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/citrus-cocktail-on-orange-yellow-stripes.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--clear-your-mind-orange-brush-lettering",
    "name": "Clear Your Mind Orange Brush Lettering",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/clear-your-mind-orange-brush-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/clear-your-mind-orange-brush-lettering.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--cool-people-live-here-pink-green-lettering",
    "name": "Cool People Live Here Pink Green Lettering",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/cool-people-live-here-pink-green-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/cool-people-live-here-pink-green-lettering.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--dance-orange-yellow-lettering-on-pink",
    "name": "Dance Orange Yellow Lettering On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/dance-orange-yellow-lettering-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/dance-orange-yellow-lettering-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--do-more-of-the-things-you-enjoy-orange",
    "name": "Do More Of The Things You Enjoy Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/do-more-of-the-things-you-enjoy-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/do-more-of-the-things-you-enjoy-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--do-more-of-what-you-love-pink-lettering",
    "name": "Do More Of What You Love Pink Lettering",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/do-more-of-what-you-love-pink-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/do-more-of-what-you-love-pink-lettering.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--flower-market-orange-yellow-flowers",
    "name": "Flower Market Orange Yellow Flowers",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/flower-market-orange-yellow-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/flower-market-orange-yellow-flowers.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--flower-market-pink-bloom-green-leaves",
    "name": "Flower Market Pink Bloom Green Leaves",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/flower-market-pink-bloom-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/flower-market-pink-bloom-green-leaves.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--glossy-pink-gummy-bear-on-yellow",
    "name": "Glossy Pink Gummy Bear On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/glossy-pink-gummy-bear-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/glossy-pink-gummy-bear-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--glossy-pink-heart-on-yellow",
    "name": "Glossy Pink Heart On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/glossy-pink-heart-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/glossy-pink-heart-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--good-vibes-great-love-orange-frame",
    "name": "Good Vibes Great Love Orange Frame",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/good-vibes-great-love-orange-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/good-vibes-great-love-orange-frame.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--hallo-orange-lettering-on-pink",
    "name": "Hallo Orange Lettering On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/hallo-orange-lettering-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/hallo-orange-lettering-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--limoncello-lemons-on-pink",
    "name": "Limoncello Lemons On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/limoncello-lemons-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/limoncello-lemons-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--love-yellow-flowing-script-on-orange",
    "name": "Love Yellow Flowing Script On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/love-yellow-flowing-script-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/love-yellow-flowing-script-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--make-magic-every-day-on-yellow",
    "name": "Make Magic Every Day On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/make-magic-every-day-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/make-magic-every-day-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--make-yourself-proud-orange-on-yellow",
    "name": "Make Yourself Proud Orange On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/make-yourself-proud-orange-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/make-yourself-proud-orange-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--more-amore-por-favor-orange-lettering",
    "name": "More Amore Por Favor Orange Lettering",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/more-amore-por-favor-orange-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/more-amore-por-favor-orange-lettering.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-and-yellow-warped-stripes",
    "name": "Orange And Yellow Warped Stripes",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-and-yellow-warped-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-and-yellow-warped-stripes.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-bell-flowers-green-leaves",
    "name": "Orange Bell Flowers Green Leaves",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-bell-flowers-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-bell-flowers-green-leaves.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-fruit-pattern-on-pink",
    "name": "Orange Fruit Pattern On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-fruit-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-fruit-pattern-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-jellyfish-with-yellow-bell",
    "name": "Orange Jellyfish With Yellow Bell",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-jellyfish-with-yellow-bell.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-jellyfish-with-yellow-bell.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-market-citrus-slice",
    "name": "Orange Market Citrus Slice",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-market-citrus-slice.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-market-citrus-slice.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-parallel-curves-yellow-circles",
    "name": "Orange Parallel Curves Yellow Circles",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-parallel-curves-yellow-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-parallel-curves-yellow-circles.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-ribbon-bow-on-pink",
    "name": "Orange Ribbon Bow On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-ribbon-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-ribbon-bow-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--orange-summer-holiday-illustration-collage",
    "name": "Orange Summer Holiday Illustration Collage",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/orange-summer-holiday-illustration-collage.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/orange-summer-holiday-illustration-collage.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pale-pink-abstract-face-on-orange",
    "name": "Pale Pink Abstract Face On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pale-pink-abstract-face-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pale-pink-abstract-face-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pale-pink-flowing-abstract-shapes",
    "name": "Pale Pink Flowing Abstract Shapes",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pale-pink-flowing-abstract-shapes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pale-pink-flowing-abstract-shapes.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pale-pink-gummy-bear-on-orange",
    "name": "Pale Pink Gummy Bear On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pale-pink-gummy-bear-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pale-pink-gummy-bear-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--peachy-orange-fruit-on-pink",
    "name": "Peachy Orange Fruit On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/peachy-orange-fruit-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/peachy-orange-fruit-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-abstract-floral-cutout-pattern",
    "name": "Pink Abstract Floral Cutout Pattern",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-abstract-floral-cutout-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-abstract-floral-cutout-pattern.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-and-yellow-spiral",
    "name": "Pink And Yellow Spiral",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-and-yellow-spiral.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-and-yellow-spiral.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-billiard-four-ball-on-orange",
    "name": "Pink Billiard Four Ball On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-billiard-four-ball-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-billiard-four-ball-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-botanical-collage-on-orange",
    "name": "Pink Botanical Collage On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-botanical-collage-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-botanical-collage-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-curved-pasta-tube-lines",
    "name": "Pink Curved Pasta Tube Lines",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-curved-pasta-tube-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-curved-pasta-tube-lines.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-ice-cream-cone-on-yellow",
    "name": "Pink Ice Cream Cone On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-ice-cream-cone-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-ice-cream-cone-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-lava-lamp-with-orange-flowers",
    "name": "Pink Lava Lamp With Orange Flowers",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-lava-lamp-with-orange-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-lava-lamp-with-orange-flowers.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-looping-line-pattern",
    "name": "Pink Looping Line Pattern",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-looping-line-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-looping-line-pattern.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-sardine-fish-pattern",
    "name": "Pink Sardine Fish Pattern",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-sardine-fish-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-sardine-fish-pattern.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-toy-bear-on-orange",
    "name": "Pink Toy Bear On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-toy-bear-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-toy-bear-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--pink-tulip-green-leaves-on-yellow",
    "name": "Pink Tulip Green Leaves On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/pink-tulip-green-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/pink-tulip-green-leaves-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--slay-the-day-pink-on-yellow",
    "name": "Slay The Day Pink On Yellow",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/slay-the-day-pink-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/slay-the-day-pink-on-yellow.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--three-pink-daisies-on-orange",
    "name": "Three Pink Daisies On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/three-pink-daisies-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/three-pink-daisies-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--three-yellow-tulips-on-pink",
    "name": "Three Yellow Tulips On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/three-yellow-tulips-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/three-yellow-tulips-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--watercolor-orange-half-on-pink",
    "name": "Watercolor Orange Half On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/watercolor-orange-half-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/watercolor-orange-half-on-pink.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--wavy-love-lettering-orange-frame",
    "name": "Wavy Love Lettering Orange Frame",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/wavy-love-lettering-orange-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/wavy-love-lettering-orange-frame.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--what-is-love-green-lettering",
    "name": "What Is Love Green Lettering",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/what-is-love-green-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/what-is-love-green-lettering.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--white-love-script-pattern-on-orange",
    "name": "White Love Script Pattern On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/white-love-script-pattern-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/white-love-script-pattern-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--yellow-banana-pattern-on-orange",
    "name": "Yellow Banana Pattern On Orange",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/yellow-banana-pattern-on-orange.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/yellow-banana-pattern-on-orange.jpg")
  },
  {
    "id": "colorful-pink-orange-yellow--yellow-rubber-duck-on-pink",
    "name": "Yellow Rubber Duck On Pink",
    "category": "Colorful Pink Orange Yellow",
    "src": window.StrayzyAsset("./assets/background-patterns/colorful-pink-orange-yellow/yellow-rubber-duck-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/colorful-pink-orange-yellow/yellow-rubber-duck-on-pink.jpg")
  },
  {
    "id": "coquette--aligned-with-beautiful-opportunities-burgundy",
    "name": "Aligned With Beautiful Opportunities Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/aligned-with-beautiful-opportunities-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/aligned-with-beautiful-opportunities-burgundy.jpg")
  },
  {
    "id": "coquette--bloom-pink-flowers-on-burgundy",
    "name": "Bloom Pink Flowers On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/bloom-pink-flowers-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/bloom-pink-flowers-on-burgundy.jpg")
  },
  {
    "id": "coquette--born-lucky-cream-on-burgundy",
    "name": "Born Lucky Cream On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/born-lucky-cream-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/born-lucky-cream-on-burgundy.jpg")
  },
  {
    "id": "coquette--bow-tied-cherries-in-scalloped-frame",
    "name": "Bow Tied Cherries In Scalloped Frame",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/bow-tied-cherries-in-scalloped-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/bow-tied-cherries-in-scalloped-frame.jpg")
  },
  {
    "id": "coquette--burgundy-and-pink-wavy-stripes",
    "name": "Burgundy And Pink Wavy Stripes",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-and-pink-wavy-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-and-pink-wavy-stripes.jpg")
  },
  {
    "id": "coquette--burgundy-cherries-on-pink",
    "name": "Burgundy Cherries On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-cherries-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-cherries-on-pink.jpg")
  },
  {
    "id": "coquette--burgundy-cherry-with-fine-ribbon-bow",
    "name": "Burgundy Cherry With Fine Ribbon Bow",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-cherry-with-fine-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-cherry-with-fine-ribbon-bow.jpg")
  },
  {
    "id": "coquette--burgundy-heart-on-cream",
    "name": "Burgundy Heart On Cream",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-heart-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-heart-on-cream.jpg")
  },
  {
    "id": "coquette--burgundy-long-ribbon-bow-on-pink",
    "name": "Burgundy Long Ribbon Bow On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-long-ribbon-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-long-ribbon-bow-on-pink.jpg")
  },
  {
    "id": "coquette--burgundy-outlined-heart-grid-on-pink",
    "name": "Burgundy Outlined Heart Grid On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/burgundy-outlined-heart-grid-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/burgundy-outlined-heart-grid-on-pink.jpg")
  },
  {
    "id": "coquette--cherry-decorated-matchbox",
    "name": "Cherry Decorated Matchbox",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cherry-decorated-matchbox.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cherry-decorated-matchbox.jpg")
  },
  {
    "id": "coquette--cherry-topped-cream-cake-on-pink",
    "name": "Cherry Topped Cream Cake On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cherry-topped-cream-cake-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cherry-topped-cream-cake-on-pink.jpg")
  },
  {
    "id": "coquette--cream-cherry-cocktail-with-bow-on-burgundy",
    "name": "Cream Cherry Cocktail With Bow On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cream-cherry-cocktail-with-bow-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cream-cherry-cocktail-with-bow-on-burgundy.jpg")
  },
  {
    "id": "coquette--cream-cowboy-boot-on-burgundy",
    "name": "Cream Cowboy Boot On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cream-cowboy-boot-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cream-cowboy-boot-on-burgundy.jpg")
  },
  {
    "id": "coquette--cream-ribbon-bow-lattice-on-burgundy",
    "name": "Cream Ribbon Bow Lattice On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cream-ribbon-bow-lattice-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cream-ribbon-bow-lattice-on-burgundy.jpg")
  },
  {
    "id": "coquette--cream-rose-line-art-on-burgundy",
    "name": "Cream Rose Line Art On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cream-rose-line-art-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cream-rose-line-art-on-burgundy.jpg")
  },
  {
    "id": "coquette--cropped-burgundy-eight-ball-on-cream",
    "name": "Cropped Burgundy Eight Ball On Cream",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cropped-burgundy-eight-ball-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cropped-burgundy-eight-ball-on-cream.jpg")
  },
  {
    "id": "coquette--cupid-angel-sitting-on-cloud",
    "name": "Cupid Angel Sitting On Cloud",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cupid-angel-sitting-on-cloud.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cupid-angel-sitting-on-cloud.jpg")
  },
  {
    "id": "coquette--cupid-cat-with-bow-and-arrow",
    "name": "Cupid Cat With Bow And Arrow",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/cupid-cat-with-bow-and-arrow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/cupid-cat-with-bow-and-arrow.jpg")
  },
  {
    "id": "coquette--feel-deeply-burgundy-script-on-pink",
    "name": "Feel Deeply Burgundy Script On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/feel-deeply-burgundy-script-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/feel-deeply-burgundy-script-on-pink.jpg")
  },
  {
    "id": "coquette--glowing-white-sparkle-on-burgundy",
    "name": "Glowing White Sparkle On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/glowing-white-sparkle-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/glowing-white-sparkle-on-burgundy.jpg")
  },
  {
    "id": "coquette--good-time-cocktail-glasses-striped-frame",
    "name": "Good Time Cocktail Glasses Striped Frame",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/good-time-cocktail-glasses-striped-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/good-time-cocktail-glasses-striped-frame.jpg")
  },
  {
    "id": "coquette--good-vibes-only-burgundy-calligraphy",
    "name": "Good Vibes Only Burgundy Calligraphy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/good-vibes-only-burgundy-calligraphy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/good-vibes-only-burgundy-calligraphy.jpg")
  },
  {
    "id": "coquette--heart-shaped-cake-and-bows-on-burgundy",
    "name": "Heart Shaped Cake And Bows On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/heart-shaped-cake-and-bows-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/heart-shaped-cake-and-bows-on-burgundy.jpg")
  },
  {
    "id": "coquette--i-deserve-more-on-burgundy",
    "name": "I Deserve More On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/i-deserve-more-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/i-deserve-more-on-burgundy.jpg")
  },
  {
    "id": "coquette--in-my-soft-girl-era-pearls",
    "name": "In My Soft Girl Era Pearls",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/in-my-soft-girl-era-pearls.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/in-my-soft-girl-era-pearls.jpg")
  },
  {
    "id": "coquette--just-breathe-cream-script-on-burgundy",
    "name": "Just Breathe Cream Script On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/just-breathe-cream-script-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/just-breathe-cream-script-on-burgundy.jpg")
  },
  {
    "id": "coquette--leopard-print-heart-on-pink",
    "name": "Leopard Print Heart On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/leopard-print-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/leopard-print-heart-on-pink.jpg")
  },
  {
    "id": "coquette--lucky-burgundy-flowing-script",
    "name": "Lucky Burgundy Flowing Script",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/lucky-burgundy-flowing-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/lucky-burgundy-flowing-script.jpg")
  },
  {
    "id": "coquette--lucky-four-leaf-clover-on-pink",
    "name": "Lucky Four Leaf Clover On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/lucky-four-leaf-clover-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/lucky-four-leaf-clover-on-pink.jpg")
  },
  {
    "id": "coquette--make-your-own-magic-pink-wavy-frame",
    "name": "Make Your Own Magic Pink Wavy Frame",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/make-your-own-magic-pink-wavy-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/make-your-own-magic-pink-wavy-frame.jpg")
  },
  {
    "id": "coquette--mon-chery-cherries-with-bow",
    "name": "Mon Chery Cherries With Bow",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/mon-chery-cherries-with-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/mon-chery-cherries-with-bow.jpg")
  },
  {
    "id": "coquette--overlapping-burgundy-heart-outlines-on-pink",
    "name": "Overlapping Burgundy Heart Outlines On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/overlapping-burgundy-heart-outlines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/overlapping-burgundy-heart-outlines-on-pink.jpg")
  },
  {
    "id": "coquette--pale-pink-leopard-spots-on-cream",
    "name": "Pale Pink Leopard Spots On Cream",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/pale-pink-leopard-spots-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/pale-pink-leopard-spots-on-cream.jpg")
  },
  {
    "id": "coquette--pink-flower-in-burgundy-scalloped-frame",
    "name": "Pink Flower In Burgundy Scalloped Frame",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/pink-flower-in-burgundy-scalloped-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/pink-flower-in-burgundy-scalloped-frame.jpg")
  },
  {
    "id": "coquette--pink-flower-line-art-on-burgundy",
    "name": "Pink Flower Line Art On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/pink-flower-line-art-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/pink-flower-line-art-on-burgundy.jpg")
  },
  {
    "id": "coquette--pink-kisses-and-hearts-on-burgundy",
    "name": "Pink Kisses And Hearts On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/pink-kisses-and-hearts-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/pink-kisses-and-hearts-on-burgundy.jpg")
  },
  {
    "id": "coquette--pink-pearl-heart-on-cream",
    "name": "Pink Pearl Heart On Cream",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/pink-pearl-heart-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/pink-pearl-heart-on-cream.jpg")
  },
  {
    "id": "coquette--seated-spotted-leopard-on-pink",
    "name": "Seated Spotted Leopard On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/seated-spotted-leopard-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/seated-spotted-leopard-on-pink.jpg")
  },
  {
    "id": "coquette--single-burgundy-heart-outline-on-cream",
    "name": "Single Burgundy Heart Outline On Cream",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/single-burgundy-heart-outline-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/single-burgundy-heart-outline-on-cream.jpg")
  },
  {
    "id": "coquette--six-coupe-glasses-champagne-tower",
    "name": "Six Coupe Glasses Champagne Tower",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/six-coupe-glasses-champagne-tower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/six-coupe-glasses-champagne-tower.jpg")
  },
  {
    "id": "coquette--soft-peace-pure-love-dove-with-rose",
    "name": "Soft Peace Pure Love Dove With Rose",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/soft-peace-pure-love-dove-with-rose.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/soft-peace-pure-love-dove-with-rose.jpg")
  },
  {
    "id": "coquette--stay-soft-with-pearl-strands",
    "name": "Stay Soft With Pearl Strands",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/stay-soft-with-pearl-strands.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/stay-soft-with-pearl-strands.jpg")
  },
  {
    "id": "coquette--te-amo-cream-script-on-burgundy",
    "name": "Te Amo Cream Script On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/te-amo-cream-script-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/te-amo-cream-script-on-burgundy.jpg")
  },
  {
    "id": "coquette--teddy-bear-with-bow-line-art",
    "name": "Teddy Bear With Bow Line Art",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/teddy-bear-with-bow-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/teddy-bear-with-bow-line-art.jpg")
  },
  {
    "id": "coquette--three-burgundy-four-point-stars-on-pink",
    "name": "Three Burgundy Four Point Stars On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/three-burgundy-four-point-stars-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/three-burgundy-four-point-stars-on-pink.jpg")
  },
  {
    "id": "coquette--three-burgundy-outline-flowers",
    "name": "Three Burgundy Outline Flowers",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/three-burgundy-outline-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/three-burgundy-outline-flowers.jpg")
  },
  {
    "id": "coquette--three-burgundy-seashell-drawings-on-pink",
    "name": "Three Burgundy Seashell Drawings On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/three-burgundy-seashell-drawings-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/three-burgundy-seashell-drawings-on-pink.jpg")
  },
  {
    "id": "coquette--two-heart-dice-on-pink",
    "name": "Two Heart Dice On Pink",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/two-heart-dice-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/two-heart-dice-on-pink.jpg")
  },
  {
    "id": "coquette--yee-haw-cowboy-boots-on-burgundy",
    "name": "Yee Haw Cowboy Boots On Burgundy",
    "category": "Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/coquette/yee-haw-cowboy-boots-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/coquette/yee-haw-cowboy-boots-on-burgundy.jpg")
  },
  {
    "id": "dopamine-pastel--be-happy-pink-smiley-card",
    "name": "Be Happy Pink Smiley Card",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/be-happy-pink-smiley-card.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/be-happy-pink-smiley-card.jpg")
  },
  {
    "id": "dopamine-pastel--black-sketched-heart-pattern-on-green",
    "name": "Black Sketched Heart Pattern On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/black-sketched-heart-pattern-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/black-sketched-heart-pattern-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--chill-fluffy-dog-holding-mug-on-pink",
    "name": "Chill Fluffy Dog Holding Mug On Pink",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/chill-fluffy-dog-holding-mug-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/chill-fluffy-dog-holding-mug-on-pink.jpg")
  },
  {
    "id": "dopamine-pastel--choose-mood-nine-smiley-faces",
    "name": "Choose Mood Nine Smiley Faces",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/choose-mood-nine-smiley-faces.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/choose-mood-nine-smiley-faces.jpg")
  },
  {
    "id": "dopamine-pastel--coffee-time-moka-pot-on-blue",
    "name": "Coffee Time Moka Pot On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/coffee-time-moka-pot-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/coffee-time-moka-pot-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--cool-people-live-here-black-on-blue",
    "name": "Cool People Live Here Black On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/cool-people-live-here-black-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/cool-people-live-here-black-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--feel-nice-three-stacked-smileys",
    "name": "Feel Nice Three Stacked Smileys",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/feel-nice-three-stacked-smileys.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/feel-nice-three-stacked-smileys.jpg")
  },
  {
    "id": "dopamine-pastel--four-pink-distorted-smileys-on-blue",
    "name": "Four Pink Distorted Smileys On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/four-pink-distorted-smileys-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/four-pink-distorted-smileys-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--fresh-pink-strawberry-black-lettering",
    "name": "Fresh Pink Strawberry Black Lettering",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/fresh-pink-strawberry-black-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/fresh-pink-strawberry-black-lettering.jpg")
  },
  {
    "id": "dopamine-pastel--good-vibes-great-love-pink-lettering",
    "name": "Good Vibes Great Love Pink Lettering",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/good-vibes-great-love-pink-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/good-vibes-great-love-pink-lettering.jpg")
  },
  {
    "id": "dopamine-pastel--green-flowing-stripes-in-blue-frame",
    "name": "Green Flowing Stripes In Blue Frame",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-flowing-stripes-in-blue-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-flowing-stripes-in-blue-frame.jpg")
  },
  {
    "id": "dopamine-pastel--green-horizontal-brush-dash-pattern",
    "name": "Green Horizontal Brush Dash Pattern",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-horizontal-brush-dash-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-horizontal-brush-dash-pattern.jpg")
  },
  {
    "id": "dopamine-pastel--green-leafy-sprig-in-white-panel",
    "name": "Green Leafy Sprig In White Panel",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-leafy-sprig-in-white-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-leafy-sprig-in-white-panel.jpg")
  },
  {
    "id": "dopamine-pastel--green-monstera-leaf",
    "name": "Green Monstera Leaf",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-monstera-leaf.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-monstera-leaf.jpg")
  },
  {
    "id": "dopamine-pastel--green-organic-curves-and-circle",
    "name": "Green Organic Curves And Circle",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-organic-curves-and-circle.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-organic-curves-and-circle.jpg")
  },
  {
    "id": "dopamine-pastel--green-smiling-alien-head-on-pink",
    "name": "Green Smiling Alien Head On Pink",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-smiling-alien-head-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-smiling-alien-head-on-pink.jpg")
  },
  {
    "id": "dopamine-pastel--green-spiral-rays-on-blue",
    "name": "Green Spiral Rays On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/green-spiral-rays-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/green-spiral-rays-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--kiwi-slice-on-pastel-blue",
    "name": "Kiwi Slice On Pastel Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/kiwi-slice-on-pastel-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/kiwi-slice-on-pastel-blue.jpg")
  },
  {
    "id": "dopamine-pastel--large-hot-pink-heart-on-blush",
    "name": "Large Hot Pink Heart On Blush",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/large-hot-pink-heart-on-blush.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/large-hot-pink-heart-on-blush.jpg")
  },
  {
    "id": "dopamine-pastel--make-today-great-pink-lettering-on-green",
    "name": "Make Today Great Pink Lettering On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/make-today-great-pink-lettering-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/make-today-great-pink-lettering-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--make-yourself-proud-pink-lettering",
    "name": "Make Yourself Proud Pink Lettering",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/make-yourself-proud-pink-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/make-yourself-proud-pink-lettering.jpg")
  },
  {
    "id": "dopamine-pastel--matcha-club-green-tea-glass",
    "name": "Matcha Club Green Tea Glass",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/matcha-club-green-tea-glass.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/matcha-club-green-tea-glass.jpg")
  },
  {
    "id": "dopamine-pastel--pink-abstract-flower-on-blue",
    "name": "Pink Abstract Flower On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-abstract-flower-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-abstract-flower-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--pink-billiard-eight-ball",
    "name": "Pink Billiard Eight Ball",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-billiard-eight-ball.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-billiard-eight-ball.jpg")
  },
  {
    "id": "dopamine-pastel--pink-blossom-with-broad-green-leaves",
    "name": "Pink Blossom With Broad Green Leaves",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-blossom-with-broad-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-blossom-with-broad-green-leaves.jpg")
  },
  {
    "id": "dopamine-pastel--pink-cherries-on-blue",
    "name": "Pink Cherries On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-cherries-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-cherries-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--pink-concentric-evil-eye",
    "name": "Pink Concentric Evil Eye",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-concentric-evil-eye.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-concentric-evil-eye.jpg")
  },
  {
    "id": "dopamine-pastel--pink-diagonal-wavy-stripe-pattern",
    "name": "Pink Diagonal Wavy Stripe Pattern",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-diagonal-wavy-stripe-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-diagonal-wavy-stripe-pattern.jpg")
  },
  {
    "id": "dopamine-pastel--pink-flower-garden-on-blue",
    "name": "Pink Flower Garden On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-flower-garden-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-flower-garden-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--pink-flowing-zebra-swirls",
    "name": "Pink Flowing Zebra Swirls",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-flowing-zebra-swirls.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-flowing-zebra-swirls.jpg")
  },
  {
    "id": "dopamine-pastel--pink-geometric-flower-green-leaves",
    "name": "Pink Geometric Flower Green Leaves",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-geometric-flower-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-geometric-flower-green-leaves.jpg")
  },
  {
    "id": "dopamine-pastel--pink-leopard-spot-pattern",
    "name": "Pink Leopard Spot Pattern",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-leopard-spot-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-leopard-spot-pattern.jpg")
  },
  {
    "id": "dopamine-pastel--pink-melting-smiley-face-pattern",
    "name": "Pink Melting Smiley Face Pattern",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-melting-smiley-face-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-melting-smiley-face-pattern.jpg")
  },
  {
    "id": "dopamine-pastel--pink-poppy-with-green-leaves",
    "name": "Pink Poppy With Green Leaves",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-poppy-with-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-poppy-with-green-leaves.jpg")
  },
  {
    "id": "dopamine-pastel--pink-zebra-stripes-on-blue",
    "name": "Pink Zebra Stripes On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/pink-zebra-stripes-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/pink-zebra-stripes-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--radiate-positivity-pink-rainbow",
    "name": "Radiate Positivity Pink Rainbow",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/radiate-positivity-pink-rainbow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/radiate-positivity-pink-rainbow.jpg")
  },
  {
    "id": "dopamine-pastel--rave-vibe-pink-melting-smileys",
    "name": "Rave Vibe Pink Melting Smileys",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/rave-vibe-pink-melting-smileys.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/rave-vibe-pink-melting-smileys.jpg")
  },
  {
    "id": "dopamine-pastel--self-love-club-pink-and-white",
    "name": "Self Love Club Pink And White",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/self-love-club-pink-and-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/self-love-club-pink-and-white.jpg")
  },
  {
    "id": "dopamine-pastel--three-outlined-pink-daisies-on-green",
    "name": "Three Outlined Pink Daisies On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/three-outlined-pink-daisies-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/three-outlined-pink-daisies-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--three-pink-flowers-green-stems",
    "name": "Three Pink Flowers Green Stems",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/three-pink-flowers-green-stems.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/three-pink-flowers-green-stems.jpg")
  },
  {
    "id": "dopamine-pastel--two-drooping-pink-flowers-blue-panel",
    "name": "Two Drooping Pink Flowers Blue Panel",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/two-drooping-pink-flowers-blue-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/two-drooping-pink-flowers-blue-panel.jpg")
  },
  {
    "id": "dopamine-pastel--two-pink-butterflies-on-green",
    "name": "Two Pink Butterflies On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/two-pink-butterflies-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/two-pink-butterflies-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--two-pink-heart-dice-on-green-lines",
    "name": "Two Pink Heart Dice On Green Lines",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/two-pink-heart-dice-on-green-lines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/two-pink-heart-dice-on-green-lines.jpg")
  },
  {
    "id": "dopamine-pastel--two-tone-green-checkerboard",
    "name": "Two Tone Green Checkerboard",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/two-tone-green-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/two-tone-green-checkerboard.jpg")
  },
  {
    "id": "dopamine-pastel--white-sparkles-pink-dots-on-green",
    "name": "White Sparkles Pink Dots On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/white-sparkles-pink-dots-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/white-sparkles-pink-dots-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--white-warped-smiley-on-green",
    "name": "White Warped Smiley On Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/white-warped-smiley-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/white-warped-smiley-on-green.jpg")
  },
  {
    "id": "dopamine-pastel--white-xoxo-on-pastel-green",
    "name": "White Xoxo On Pastel Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/white-xoxo-on-pastel-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/white-xoxo-on-pastel-green.jpg")
  },
  {
    "id": "dopamine-pastel--you-are-loved-black-script-on-blue",
    "name": "You Are Loved Black Script On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/you-are-loved-black-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/you-are-loved-black-script-on-blue.jpg")
  },
  {
    "id": "dopamine-pastel--you-are-stronger-than-you-think-green",
    "name": "You Are Stronger Than You Think Green",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/you-are-stronger-than-you-think-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/you-are-stronger-than-you-think-green.jpg")
  },
  {
    "id": "dopamine-pastel--you-got-this-pink-on-blue",
    "name": "You Got This Pink On Blue",
    "category": "Dopamine Pastel",
    "src": window.StrayzyAsset("./assets/background-patterns/dopamine-pastel/you-got-this-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/dopamine-pastel/you-got-this-pink-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-coral-branches-on-pink",
    "name": "Blue Coral Branches On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-coral-branches-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-coral-branches-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-cowrie-shell-outline",
    "name": "Blue Cowrie Shell Outline",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-cowrie-shell-outline.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-cowrie-shell-outline.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-leopard-spots-on-pink",
    "name": "Blue Leopard Spots On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-leopard-spots-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-leopard-spots-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-looping-squiggle-on-pink",
    "name": "Blue Looping Squiggle On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-looping-squiggle-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-looping-squiggle-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-outlined-pink-conch-shell",
    "name": "Blue Outlined Pink Conch Shell",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-outlined-pink-conch-shell.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-outlined-pink-conch-shell.jpg")
  },
  {
    "id": "eclectic-dopamine--blue-wavy-contour-stripes-on-white",
    "name": "Blue Wavy Contour Stripes On White",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/blue-wavy-contour-stripes-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/blue-wavy-contour-stripes-on-white.jpg")
  },
  {
    "id": "eclectic-dopamine--ciao-bella-on-pink-vertical-stripes",
    "name": "Ciao Bella On Pink Vertical Stripes",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/ciao-bella-on-pink-vertical-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/ciao-bella-on-pink-vertical-stripes.jpg")
  },
  {
    "id": "eclectic-dopamine--cropped-pink-eight-ball-on-blue",
    "name": "Cropped Pink Eight Ball On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/cropped-pink-eight-ball-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/cropped-pink-eight-ball-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--drink-up-red-cherry-cocktail",
    "name": "Drink Up Red Cherry Cocktail",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/drink-up-red-cherry-cocktail.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/drink-up-red-cherry-cocktail.jpg")
  },
  {
    "id": "eclectic-dopamine--feel-deeply-blue-brush-lettering",
    "name": "Feel Deeply Blue Brush Lettering",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/feel-deeply-blue-brush-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/feel-deeply-blue-brush-lettering.jpg")
  },
  {
    "id": "eclectic-dopamine--five-pink-daisies-on-blue",
    "name": "Five Pink Daisies On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/five-pink-daisies-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/five-pink-daisies-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--four-white-sparkles-on-blue",
    "name": "Four White Sparkles On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/four-white-sparkles-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/four-white-sparkles-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--good-things-take-time-white-on-blue",
    "name": "Good Things Take Time White On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/good-things-take-time-white-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/good-things-take-time-white-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--limoncello-blue-lemon-line-art",
    "name": "Limoncello Blue Lemon Line Art",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/limoncello-blue-lemon-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/limoncello-blue-lemon-line-art.jpg")
  },
  {
    "id": "eclectic-dopamine--main-character-energy-red-frame",
    "name": "Main Character Energy Red Frame",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/main-character-energy-red-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/main-character-energy-red-frame.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-abstract-tulip-on-blue",
    "name": "Pink Abstract Tulip On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-abstract-tulip-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-abstract-tulip-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-and-white-flowing-swirls",
    "name": "Pink And White Flowing Swirls",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-and-white-flowing-swirls.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-and-white-flowing-swirls.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-cherry-and-bow-outline-on-blue",
    "name": "Pink Cherry And Bow Outline On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-cherry-and-bow-outline-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-cherry-and-bow-outline-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-flower-red-center-blue-leaves",
    "name": "Pink Flower Red Center Blue Leaves",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-flower-red-center-blue-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-flower-red-center-blue-leaves.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-pineapple-line-art-on-blue",
    "name": "Pink Pineapple Line Art On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-pineapple-line-art-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-pineapple-line-art-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-spotted-seashell-on-blue",
    "name": "Pink Spotted Seashell On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-spotted-seashell-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-spotted-seashell-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-topographic-lines-on-blue",
    "name": "Pink Topographic Lines On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-topographic-lines-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-topographic-lines-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pink-warped-wire-grid-on-blue",
    "name": "Pink Warped Wire Grid On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pink-warped-wire-grid-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pink-warped-wire-grid-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--pretty-things-take-time-blue-on-pink",
    "name": "Pretty Things Take Time Blue On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/pretty-things-take-time-blue-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/pretty-things-take-time-blue-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-and-pink-checkerboard",
    "name": "Red And Pink Checkerboard",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-and-pink-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-and-pink-checkerboard.jpg")
  },
  {
    "id": "eclectic-dopamine--red-and-white-warped-checkerboard",
    "name": "Red And White Warped Checkerboard",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-and-white-warped-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-and-white-warped-checkerboard.jpg")
  },
  {
    "id": "eclectic-dopamine--red-bikini-on-clothesline",
    "name": "Red Bikini On Clothesline",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-bikini-on-clothesline.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-bikini-on-clothesline.jpg")
  },
  {
    "id": "eclectic-dopamine--red-bow-tied-cherries-pink-dotted-frame",
    "name": "Red Bow Tied Cherries Pink Dotted Frame",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-bow-tied-cherries-pink-dotted-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-bow-tied-cherries-pink-dotted-frame.jpg")
  },
  {
    "id": "eclectic-dopamine--red-cherries-and-bow-striped-arch-frame",
    "name": "Red Cherries And Bow Striped Arch Frame",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-cherries-and-bow-striped-arch-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-cherries-and-bow-striped-arch-frame.jpg")
  },
  {
    "id": "eclectic-dopamine--red-flowing-abstract-stripes-on-white",
    "name": "Red Flowing Abstract Stripes On White",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-flowing-abstract-stripes-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-flowing-abstract-stripes-on-white.jpg")
  },
  {
    "id": "eclectic-dopamine--red-lipstick-kiss-on-pink",
    "name": "Red Lipstick Kiss On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-lipstick-kiss-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-lipstick-kiss-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-lipstick-kiss-pattern-on-pink",
    "name": "Red Lipstick Kiss Pattern On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-lipstick-kiss-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-lipstick-kiss-pattern-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-organic-spiral-on-white",
    "name": "Red Organic Spiral On White",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-organic-spiral-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-organic-spiral-on-white.jpg")
  },
  {
    "id": "eclectic-dopamine--red-scribbled-heart-on-pink",
    "name": "Red Scribbled Heart On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-scribbled-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-scribbled-heart-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-sketched-ribbon-bow",
    "name": "Red Sketched Ribbon Bow",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-sketched-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-sketched-ribbon-bow.jpg")
  },
  {
    "id": "eclectic-dopamine--red-striped-swimsuit-on-pink",
    "name": "Red Striped Swimsuit On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-striped-swimsuit-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-striped-swimsuit-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-striped-swimsuit-torso-on-pink",
    "name": "Red Striped Swimsuit Torso On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-striped-swimsuit-torso-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-striped-swimsuit-torso-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-swirling-botanical-fronds",
    "name": "Red Swirling Botanical Fronds",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-swirling-botanical-fronds.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-swirling-botanical-fronds.jpg")
  },
  {
    "id": "eclectic-dopamine--red-tomato-vine-outline-on-pink",
    "name": "Red Tomato Vine Outline On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-tomato-vine-outline-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-tomato-vine-outline-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--red-xoxo-on-white",
    "name": "Red Xoxo On White",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/red-xoxo-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/red-xoxo-on-white.jpg")
  },
  {
    "id": "eclectic-dopamine--repeated-i-love-you-pink-on-blue",
    "name": "Repeated I Love You Pink On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/repeated-i-love-you-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/repeated-i-love-you-pink-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--small-steps-every-day-red-script",
    "name": "Small Steps Every Day Red Script",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/small-steps-every-day-red-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/small-steps-every-day-red-script.jpg")
  },
  {
    "id": "eclectic-dopamine--three-blue-eyes-on-pink",
    "name": "Three Blue Eyes On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/three-blue-eyes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/three-blue-eyes-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--three-blue-fish-line-drawings",
    "name": "Three Blue Fish Line Drawings",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/three-blue-fish-line-drawings.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/three-blue-fish-line-drawings.jpg")
  },
  {
    "id": "eclectic-dopamine--today-i-choose-joy-pink-on-blue",
    "name": "Today I Choose Joy Pink On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/today-i-choose-joy-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/today-i-choose-joy-pink-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--too-pretty-to-stress-pink-on-blue",
    "name": "Too Pretty To Stress Pink On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/too-pretty-to-stress-pink-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/too-pretty-to-stress-pink-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--white-flower-red-panel-on-pink",
    "name": "White Flower Red Panel On Pink",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/white-flower-red-panel-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/white-flower-red-panel-on-pink.jpg")
  },
  {
    "id": "eclectic-dopamine--white-sardine-tin-on-blue",
    "name": "White Sardine Tin On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/white-sardine-tin-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/white-sardine-tin-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--white-vertical-looping-lines-on-blue",
    "name": "White Vertical Looping Lines On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/white-vertical-looping-lines-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/white-vertical-looping-lines-on-blue.jpg")
  },
  {
    "id": "eclectic-dopamine--you-got-this-pink-script-on-blue",
    "name": "You Got This Pink Script On Blue",
    "category": "Eclectic Dopamine",
    "src": window.StrayzyAsset("./assets/background-patterns/eclectic-dopamine/you-got-this-pink-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/eclectic-dopamine/you-got-this-pink-script-on-blue.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-daisy-garden-on-purple",
    "name": "Matisse Cream Daisy Garden On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-daisy-garden-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-daisy-garden-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-daisy-purple-center-on-pink",
    "name": "Matisse Cream Daisy Purple Center On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-daisy-purple-center-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-daisy-purple-center-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-flower-green-stem-on-purple",
    "name": "Matisse Cream Flower Green Stem On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-flower-green-stem-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-flower-green-stem-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-flower-yellow-outlined-leaves-on-purple",
    "name": "Matisse Cream Flower Yellow Outlined Leaves On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-flower-yellow-outlined-leaves-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-flower-yellow-outlined-leaves-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-flowers-and-green-foliage-on-pink",
    "name": "Matisse Cream Flowers And Green Foliage On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-flowers-and-green-foliage-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-flowers-and-green-foliage-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-pointed-flower-green-leaves-on-pink",
    "name": "Matisse Cream Pointed Flower Green Leaves On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-pointed-flower-green-leaves-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-pointed-flower-green-leaves-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-sideways-flower-on-purple",
    "name": "Matisse Cream Sideways Flower On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-sideways-flower-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-sideways-flower-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-cream-wavy-leafy-branch-on-pink",
    "name": "Matisse Cream Wavy Leafy Branch On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-cream-wavy-leafy-branch-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-cream-wavy-leafy-branch-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-five-yellow-daisies-cream-stems-on-purple",
    "name": "Matisse Five Yellow Daisies Cream Stems On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-five-yellow-daisies-cream-stems-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-five-yellow-daisies-cream-stems-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-green-monstera-leaf-on-yellow",
    "name": "Matisse Green Monstera Leaf On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-green-monstera-leaf-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-green-monstera-leaf-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-fan-petals-green-base",
    "name": "Matisse Pink Fan Petals Green Base",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-fan-petals-green-base.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-fan-petals-green-base.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-flower-cream-flowing-leaves-on-purple",
    "name": "Matisse Pink Flower Cream Flowing Leaves On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-flower-cream-flowing-leaves-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-flower-cream-flowing-leaves-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-monstera-leaf-on-yellow",
    "name": "Matisse Pink Monstera Leaf On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-monstera-leaf-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-monstera-leaf-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-purple-blossom-with-dark-green-leaves",
    "name": "Matisse Pink Purple Blossom With Dark Green Leaves",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-purple-blossom-with-dark-green-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-purple-blossom-with-dark-green-leaves.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-round-flower-green-layered-leaves",
    "name": "Matisse Pink Round Flower Green Layered Leaves",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-round-flower-green-layered-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-round-flower-green-layered-leaves.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-round-flowers-green-leaves-on-yellow",
    "name": "Matisse Pink Round Flowers Green Leaves On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-round-flowers-green-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-round-flowers-green-leaves-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-trumpet-flower-garden-on-yellow",
    "name": "Matisse Pink Trumpet Flower Garden On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-trumpet-flower-garden-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-trumpet-flower-garden-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-pink-yellow-flowers-with-curling-green-stems",
    "name": "Matisse Pink Yellow Flowers With Curling Green Stems",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-pink-yellow-flowers-with-curling-green-stems.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-pink-yellow-flowers-with-curling-green-stems.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-and-pink-flowers-cream-leaves-on-yellow",
    "name": "Matisse Purple And Pink Flowers Cream Leaves On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-and-pink-flowers-cream-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-and-pink-flowers-cream-leaves-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-and-pink-tulip-silhouettes",
    "name": "Matisse Purple And Pink Tulip Silhouettes",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-and-pink-tulip-silhouettes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-and-pink-tulip-silhouettes.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-bloom-green-stem-on-cream",
    "name": "Matisse Purple Bloom Green Stem On Cream",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-bloom-green-stem-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-bloom-green-stem-on-cream.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-blossom-pattern-on-pink",
    "name": "Matisse Purple Blossom Pattern On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-blossom-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-blossom-pattern-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-drooping-ribbon-petals-on-cream",
    "name": "Matisse Purple Drooping Ribbon Petals On Cream",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-drooping-ribbon-petals-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-drooping-ribbon-petals-on-cream.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-eight-petal-flower-yellow-center",
    "name": "Matisse Purple Eight Petal Flower Yellow Center",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-eight-petal-flower-yellow-center.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-eight-petal-flower-yellow-center.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-fan-shaped-petals-on-cream",
    "name": "Matisse Purple Fan Shaped Petals On Cream",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-fan-shaped-petals-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-fan-shaped-petals-on-cream.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-fern-frond-on-yellow",
    "name": "Matisse Purple Fern Frond On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-fern-frond-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-fern-frond-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-flower-green-leaves-on-yellow",
    "name": "Matisse Purple Flower Green Leaves On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-flower-green-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-flower-green-leaves-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-flower-pink-oval-center",
    "name": "Matisse Purple Flower Pink Oval Center",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-flower-pink-oval-center.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-flower-pink-oval-center.jpg")
  },
  {
    "id": "floral-matisse--matisse-purple-trumpet-flowers-green-leaves-on-yellow",
    "name": "Matisse Purple Trumpet Flowers Green Leaves On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-purple-trumpet-flowers-green-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-purple-trumpet-flowers-green-leaves-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-single-pink-daisy-on-yellow",
    "name": "Matisse Single Pink Daisy On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-single-pink-daisy-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-single-pink-daisy-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-three-pink-daisies-on-yellow",
    "name": "Matisse Three Pink Daisies On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-three-pink-daisies-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-three-pink-daisies-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-three-pink-flowers-green-stems-on-cream",
    "name": "Matisse Three Pink Flowers Green Stems On Cream",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-three-pink-flowers-green-stems-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-three-pink-flowers-green-stems-on-cream.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-cream-flowers-purple-centers-on-pink",
    "name": "Matisse Two Cream Flowers Purple Centers On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-cream-flowers-purple-centers-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-cream-flowers-purple-centers-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-cream-leafy-vines-on-pink",
    "name": "Matisse Two Cream Leafy Vines On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-cream-leafy-vines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-cream-leafy-vines-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-cream-tulips-green-stems-on-purple",
    "name": "Matisse Two Cream Tulips Green Stems On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-cream-tulips-green-stems-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-cream-tulips-green-stems-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-drooping-yellow-flowers-on-purple",
    "name": "Matisse Two Drooping Yellow Flowers On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-drooping-yellow-flowers-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-drooping-yellow-flowers-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-pink-flowers-cream-centers-on-yellow",
    "name": "Matisse Two Pink Flowers Cream Centers On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-pink-flowers-cream-centers-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-pink-flowers-cream-centers-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-pink-flowers-green-leaves-on-yellow",
    "name": "Matisse Two Pink Flowers Green Leaves On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-pink-flowers-green-leaves-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-pink-flowers-green-leaves-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-purple-buds-green-wavy-stems",
    "name": "Matisse Two Purple Buds Green Wavy Stems",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-purple-buds-green-wavy-stems.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-purple-buds-green-wavy-stems.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-purple-flowers-pink-centers-on-yellow",
    "name": "Matisse Two Purple Flowers Pink Centers On Yellow",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-purple-flowers-pink-centers-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-purple-flowers-pink-centers-on-yellow.jpg")
  },
  {
    "id": "floral-matisse--matisse-two-yellow-tulips-cream-leaves-on-purple",
    "name": "Matisse Two Yellow Tulips Cream Leaves On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-two-yellow-tulips-cream-leaves-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-two-yellow-tulips-cream-leaves-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-abstract-petals-on-purple",
    "name": "Matisse Yellow Abstract Petals On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-abstract-petals-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-abstract-petals-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-central-flower-ornamental-purple-panel",
    "name": "Matisse Yellow Central Flower Ornamental Purple Panel",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-central-flower-ornamental-purple-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-central-flower-ornamental-purple-panel.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-cup-shaped-flower-on-pink",
    "name": "Matisse Yellow Cup Shaped Flower On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-cup-shaped-flower-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-cup-shaped-flower-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-daisy-pattern-on-pink",
    "name": "Matisse Yellow Daisy Pattern On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-daisy-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-daisy-pattern-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-daisy-pattern-purple-centers-on-pink",
    "name": "Matisse Yellow Daisy Pattern Purple Centers On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-daisy-pattern-purple-centers-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-daisy-pattern-purple-centers-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-flower-bouquet-cream-stems-on-pink",
    "name": "Matisse Yellow Flower Bouquet Cream Stems On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-flower-bouquet-cream-stems-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-flower-bouquet-cream-stems-on-pink.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-flower-cream-looping-stem-on-purple",
    "name": "Matisse Yellow Flower Cream Looping Stem On Purple",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-flower-cream-looping-stem-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-flower-cream-looping-stem-on-purple.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-flower-green-leaves-striped-vase",
    "name": "Matisse Yellow Flower Green Leaves Striped Vase",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-flower-green-leaves-striped-vase.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-flower-green-leaves-striped-vase.jpg")
  },
  {
    "id": "floral-matisse--matisse-yellow-long-petal-daisy-on-pink",
    "name": "Matisse Yellow Long Petal Daisy On Pink",
    "category": "Floral Matisse",
    "src": window.StrayzyAsset("./assets/background-patterns/floral-matisse/matisse-yellow-long-petal-daisy-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/floral-matisse/matisse-yellow-long-petal-daisy-on-pink.jpg")
  },
  {
    "id": "kitchen--aperol-party-cocktail-blue-line-art",
    "name": "Aperol Party Cocktail Blue Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/aperol-party-cocktail-blue-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/aperol-party-cocktail-blue-line-art.jpg")
  },
  {
    "id": "kitchen--banana-bunch-on-red-pink-stripes",
    "name": "Banana Bunch On Red Pink Stripes",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/banana-bunch-on-red-pink-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/banana-bunch-on-red-pink-stripes.jpg")
  },
  {
    "id": "kitchen--black-food-and-drink-doodle-pattern",
    "name": "Black Food And Drink Doodle Pattern",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/black-food-and-drink-doodle-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/black-food-and-drink-doodle-pattern.jpg")
  },
  {
    "id": "kitchen--black-vegetable-doodle-pattern-on-yellow",
    "name": "Black Vegetable Doodle Pattern On Yellow",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/black-vegetable-doodle-pattern-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/black-vegetable-doodle-pattern-on-yellow.jpg")
  },
  {
    "id": "kitchen--bon-appetit-croissant-with-pink-bow",
    "name": "Bon Appetit Croissant With Pink Bow",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/bon-appetit-croissant-with-pink-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/bon-appetit-croissant-with-pink-bow.jpg")
  },
  {
    "id": "kitchen--bon-appetit-pink-text-cream-panel-blue-frame",
    "name": "Bon Appetit Pink Text Cream Panel Blue Frame",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/bon-appetit-pink-text-cream-panel-blue-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/bon-appetit-pink-text-cream-panel-blue-frame.jpg")
  },
  {
    "id": "kitchen--bon-appetit-pizza-slice-on-pink",
    "name": "Bon Appetit Pizza Slice On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/bon-appetit-pizza-slice-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/bon-appetit-pizza-slice-on-pink.jpg")
  },
  {
    "id": "kitchen--bonjour-croissant-and-coffee",
    "name": "Bonjour Croissant And Coffee",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/bonjour-croissant-and-coffee.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/bonjour-croissant-and-coffee.jpg")
  },
  {
    "id": "kitchen--breakfast-boiled-egg-on-pink",
    "name": "Breakfast Boiled Egg On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/breakfast-boiled-egg-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/breakfast-boiled-egg-on-pink.jpg")
  },
  {
    "id": "kitchen--breakfast-club-eggs-sausage-toast-plate",
    "name": "Breakfast Club Eggs Sausage Toast Plate",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/breakfast-club-eggs-sausage-toast-plate.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/breakfast-club-eggs-sausage-toast-plate.jpg")
  },
  {
    "id": "kitchen--cheers-three-hands-with-coupe-glasses-on-pink",
    "name": "Cheers Three Hands With Coupe Glasses On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/cheers-three-hands-with-coupe-glasses-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/cheers-three-hands-with-coupe-glasses-on-pink.jpg")
  },
  {
    "id": "kitchen--cin-cin-bow-tied-coupe-glasses",
    "name": "Cin Cin Bow Tied Coupe Glasses",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/cin-cin-bow-tied-coupe-glasses.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/cin-cin-bow-tied-coupe-glasses.jpg")
  },
  {
    "id": "kitchen--cin-cin-pink-lettering-on-purple",
    "name": "Cin Cin Pink Lettering On Purple",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/cin-cin-pink-lettering-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/cin-cin-pink-lettering-on-purple.jpg")
  },
  {
    "id": "kitchen--coffee-and-croissant-on-green",
    "name": "Coffee And Croissant On Green",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/coffee-and-croissant-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/coffee-and-croissant-on-green.jpg")
  },
  {
    "id": "kitchen--coffee-blue-moka-pot-line-art",
    "name": "Coffee Blue Moka Pot Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/coffee-blue-moka-pot-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/coffee-blue-moka-pot-line-art.jpg")
  },
  {
    "id": "kitchen--coffee-club-lover-moka-pot-cup-croissant",
    "name": "Coffee Club Lover Moka Pot Cup Croissant",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/coffee-club-lover-moka-pot-cup-croissant.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/coffee-club-lover-moka-pot-cup-croissant.jpg")
  },
  {
    "id": "kitchen--coffee-time-latte-line-art-on-burgundy",
    "name": "Coffee Time Latte Line Art On Burgundy",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/coffee-time-latte-line-art-on-burgundy.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/coffee-time-latte-line-art-on-burgundy.jpg")
  },
  {
    "id": "kitchen--drink-up-cherry-cocktail-burgundy-frame",
    "name": "Drink Up Cherry Cocktail Burgundy Frame",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/drink-up-cherry-cocktail-burgundy-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/drink-up-cherry-cocktail-burgundy-frame.jpg")
  },
  {
    "id": "kitchen--eat-green-avocado-on-pink",
    "name": "Eat Green Avocado On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/eat-green-avocado-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/eat-green-avocado-on-pink.jpg")
  },
  {
    "id": "kitchen--extra-spicy-red-chili-pepper-pattern",
    "name": "Extra Spicy Red Chili Pepper Pattern",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/extra-spicy-red-chili-pepper-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/extra-spicy-red-chili-pepper-pattern.jpg")
  },
  {
    "id": "kitchen--four-colorful-sardines-on-blue",
    "name": "Four Colorful Sardines On Blue",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/four-colorful-sardines-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/four-colorful-sardines-on-blue.jpg")
  },
  {
    "id": "kitchen--fruit-market-cherry-line-art",
    "name": "Fruit Market Cherry Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/fruit-market-cherry-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/fruit-market-cherry-line-art.jpg")
  },
  {
    "id": "kitchen--fruit-market-strawberries-on-pink",
    "name": "Fruit Market Strawberries On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/fruit-market-strawberries-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/fruit-market-strawberries-on-pink.jpg")
  },
  {
    "id": "kitchen--fruit-market-strawberry-line-art",
    "name": "Fruit Market Strawberry Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/fruit-market-strawberry-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/fruit-market-strawberry-line-art.jpg")
  },
  {
    "id": "kitchen--good-coffee-good-time-cartoon-cup",
    "name": "Good Coffee Good Time Cartoon Cup",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/good-coffee-good-time-cartoon-cup.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/good-coffee-good-time-cartoon-cup.jpg")
  },
  {
    "id": "kitchen--lets-cook-cracked-egg-on-brown",
    "name": "Lets Cook Cracked Egg On Brown",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/lets-cook-cracked-egg-on-brown.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/lets-cook-cracked-egg-on-brown.jpg")
  },
  {
    "id": "kitchen--limoncello-yellow-lemon-on-purple",
    "name": "Limoncello Yellow Lemon On Purple",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/limoncello-yellow-lemon-on-purple.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/limoncello-yellow-lemon-on-purple.jpg")
  },
  {
    "id": "kitchen--ma-cherie-burgundy-cherries",
    "name": "Ma Cherie Burgundy Cherries",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/ma-cherie-burgundy-cherries.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/ma-cherie-burgundy-cherries.jpg")
  },
  {
    "id": "kitchen--matcha-club-iced-green-tea",
    "name": "Matcha Club Iced Green Tea",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/matcha-club-iced-green-tea.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/matcha-club-iced-green-tea.jpg")
  },
  {
    "id": "kitchen--more-coffee-heart-patterned-mug",
    "name": "More Coffee Heart Patterned Mug",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/more-coffee-heart-patterned-mug.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/more-coffee-heart-patterned-mug.jpg")
  },
  {
    "id": "kitchen--more-wine-two-glasses-on-yellow",
    "name": "More Wine Two Glasses On Yellow",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/more-wine-two-glasses-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/more-wine-two-glasses-on-yellow.jpg")
  },
  {
    "id": "kitchen--orange-market-fruit-in-wavy-frame",
    "name": "Orange Market Fruit In Wavy Frame",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/orange-market-fruit-in-wavy-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/orange-market-fruit-in-wavy-frame.jpg")
  },
  {
    "id": "kitchen--pancake-day-syrup-stack-orange-checkerboard",
    "name": "Pancake Day Syrup Stack Orange Checkerboard",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pancake-day-syrup-stack-orange-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pancake-day-syrup-stack-orange-checkerboard.jpg")
  },
  {
    "id": "kitchen--pasta-lover-club-noodle-bowl-on-pink",
    "name": "Pasta Lover Club Noodle Bowl On Pink",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pasta-lover-club-noodle-bowl-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pasta-lover-club-noodle-bowl-on-pink.jpg")
  },
  {
    "id": "kitchen--pasta-lover-fork-with-spaghetti",
    "name": "Pasta Lover Fork With Spaghetti",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pasta-lover-fork-with-spaghetti.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pasta-lover-fork-with-spaghetti.jpg")
  },
  {
    "id": "kitchen--pasta-spaghetti-nest-line-art",
    "name": "Pasta Spaghetti Nest Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pasta-spaghetti-nest-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pasta-spaghetti-nest-line-art.jpg")
  },
  {
    "id": "kitchen--pink-sardine-tin-on-light-blue",
    "name": "Pink Sardine Tin On Light Blue",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pink-sardine-tin-on-light-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pink-sardine-tin-on-light-blue.jpg")
  },
  {
    "id": "kitchen--pizza-pasta-red-spaghetti-line-art",
    "name": "Pizza Pasta Red Spaghetti Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/pizza-pasta-red-spaghetti-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/pizza-pasta-red-spaghetti-line-art.jpg")
  },
  {
    "id": "kitchen--raspberries-on-red-pink-grid",
    "name": "Raspberries On Red Pink Grid",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/raspberries-on-red-pink-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/raspberries-on-red-pink-grid.jpg")
  },
  {
    "id": "kitchen--red-cherries-with-ribbon-bow-on-white",
    "name": "Red Cherries With Ribbon Bow On White",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/red-cherries-with-ribbon-bow-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/red-cherries-with-ribbon-bow-on-white.jpg")
  },
  {
    "id": "kitchen--red-tomato-vine-pattern",
    "name": "Red Tomato Vine Pattern",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/red-tomato-vine-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/red-tomato-vine-pattern.jpg")
  },
  {
    "id": "kitchen--sardine-tin-in-white-looped-frame-on-blue",
    "name": "Sardine Tin In White Looped Frame On Blue",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/sardine-tin-in-white-looped-frame-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/sardine-tin-in-white-looped-frame-on-blue.jpg")
  },
  {
    "id": "kitchen--stay-sweet-heart-shaped-cake",
    "name": "Stay Sweet Heart Shaped Cake",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/stay-sweet-heart-shaped-cake.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/stay-sweet-heart-shaped-cake.jpg")
  },
  {
    "id": "kitchen--sweet-berry-strawberry-pink-panel",
    "name": "Sweet Berry Strawberry Pink Panel",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/sweet-berry-strawberry-pink-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/sweet-berry-strawberry-pink-panel.jpg")
  },
  {
    "id": "kitchen--three-painted-mangoes",
    "name": "Three Painted Mangoes",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/three-painted-mangoes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/three-painted-mangoes.jpg")
  },
  {
    "id": "kitchen--two-pretzels-on-yellow",
    "name": "Two Pretzels On Yellow",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/two-pretzels-on-yellow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/two-pretzels-on-yellow.jpg")
  },
  {
    "id": "kitchen--yellow-lemon-on-blue-pink-grid",
    "name": "Yellow Lemon On Blue Pink Grid",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/yellow-lemon-on-blue-pink-grid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/yellow-lemon-on-blue-pink-grid.jpg")
  },
  {
    "id": "kitchen--yum-golden-waffle-stack-on-blue",
    "name": "Yum Golden Waffle Stack On Blue",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/yum-golden-waffle-stack-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/yum-golden-waffle-stack-on-blue.jpg")
  },
  {
    "id": "kitchen--yum-two-tier-cake-line-art",
    "name": "Yum Two Tier Cake Line Art",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/yum-two-tier-cake-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/yum-two-tier-cake-line-art.jpg")
  },
  {
    "id": "kitchen--yummy-pink-macaron",
    "name": "Yummy Pink Macaron",
    "category": "Kitchen",
    "src": window.StrayzyAsset("./assets/background-patterns/kitchen/yummy-pink-macaron.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/kitchen/yummy-pink-macaron.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--abstract-face-over-pink-brush-strokes",
    "name": "Abstract Face Over Pink Brush Strokes",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/abstract-face-over-pink-brush-strokes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/abstract-face-over-pink-brush-strokes.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-circles-and-squares-checkerboard",
    "name": "Burgundy Circles And Squares Checkerboard",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-circles-and-squares-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-circles-and-squares-checkerboard.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-expanding-spiral-on-pink",
    "name": "Burgundy Expanding Spiral On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-expanding-spiral-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-expanding-spiral-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-leafy-branch-outline-on-cream",
    "name": "Burgundy Leafy Branch Outline On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-leafy-branch-outline-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-leafy-branch-outline-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-rounded-leafy-branch-on-pink",
    "name": "Burgundy Rounded Leafy Branch On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-rounded-leafy-branch-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-rounded-leafy-branch-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-spiral-over-cream-oval-on-pink",
    "name": "Burgundy Spiral Over Cream Oval On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-spiral-over-cream-oval-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-spiral-over-cream-oval-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-topographic-lines-on-cream",
    "name": "Burgundy Topographic Lines On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-topographic-lines-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-topographic-lines-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--burgundy-warped-ribbon-lines-on-cream",
    "name": "Burgundy Warped Ribbon Lines On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/burgundy-warped-ribbon-lines-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/burgundy-warped-ribbon-lines-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-abstract-leaf-on-terracotta",
    "name": "Cream Abstract Leaf On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-abstract-leaf-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-abstract-leaf-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-arch-and-terracotta-oval-on-pink",
    "name": "Cream Arch And Terracotta Oval On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-arch-and-terracotta-oval-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-arch-and-terracotta-oval-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-cutout-and-terracotta-oval-on-pink",
    "name": "Cream Cutout And Terracotta Oval On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-cutout-and-terracotta-oval-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-cutout-and-terracotta-oval-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-flowing-fine-stripes-on-pink",
    "name": "Cream Flowing Fine Stripes On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-flowing-fine-stripes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-flowing-fine-stripes-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-flowing-stripes-on-terracotta",
    "name": "Cream Flowing Stripes On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-flowing-stripes-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-flowing-stripes-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-horizontal-s-shaped-lines-on-terracotta",
    "name": "Cream Horizontal S Shaped Lines On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-horizontal-s-shaped-lines-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-horizontal-s-shaped-lines-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-intersecting-arch-lines-on-pink",
    "name": "Cream Intersecting Arch Lines On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-intersecting-arch-lines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-intersecting-arch-lines-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-intersecting-brush-strokes-on-pink",
    "name": "Cream Intersecting Brush Strokes On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-intersecting-brush-strokes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-intersecting-brush-strokes-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-marbled-swirls-on-terracotta",
    "name": "Cream Marbled Swirls On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-marbled-swirls-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-marbled-swirls-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-scribbled-circles-on-terracotta",
    "name": "Cream Scribbled Circles On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-scribbled-circles-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-scribbled-circles-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-sketched-eye-on-terracotta",
    "name": "Cream Sketched Eye On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-sketched-eye-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-sketched-eye-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-upward-finger-shape-on-terracotta",
    "name": "Cream Upward Finger Shape On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-upward-finger-shape-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-upward-finger-shape-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--cream-warped-stripes-in-terracotta-frame",
    "name": "Cream Warped Stripes In Terracotta Frame",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/cream-warped-stripes-in-terracotta-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/cream-warped-stripes-in-terracotta-frame.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--dark-red-organic-contour-pattern",
    "name": "Dark Red Organic Contour Pattern",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/dark-red-organic-contour-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/dark-red-organic-contour-pattern.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--eight-burgundy-semicircles-on-cream",
    "name": "Eight Burgundy Semicircles On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/eight-burgundy-semicircles-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/eight-burgundy-semicircles-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--four-burgundy-face-outlines-on-pink",
    "name": "Four Burgundy Face Outlines On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/four-burgundy-face-outlines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/four-burgundy-face-outlines-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-and-cream-irregular-vertical-stripes",
    "name": "Pink And Cream Irregular Vertical Stripes",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-and-cream-irregular-vertical-stripes.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-and-cream-irregular-vertical-stripes.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-angular-lattice-on-terracotta",
    "name": "Pink Angular Lattice On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-angular-lattice-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-angular-lattice-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-cream-terracotta-abstract-collage",
    "name": "Pink Cream Terracotta Abstract Collage",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-cream-terracotta-abstract-collage.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-cream-terracotta-abstract-collage.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-gradient-circle-and-semicircles",
    "name": "Pink Gradient Circle And Semicircles",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-gradient-circle-and-semicircles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-gradient-circle-and-semicircles.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-leafy-sprig-on-terracotta",
    "name": "Pink Leafy Sprig On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-leafy-sprig-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-leafy-sprig-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-organic-squiggle-cluster-on-terracotta",
    "name": "Pink Organic Squiggle Cluster On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-organic-squiggle-cluster-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-organic-squiggle-cluster-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-pointed-leafy-sprig-on-terracotta",
    "name": "Pink Pointed Leafy Sprig On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-pointed-leafy-sprig-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-pointed-leafy-sprig-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--pink-zebra-stripes-in-burgundy-panel",
    "name": "Pink Zebra Stripes In Burgundy Panel",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/pink-zebra-stripes-in-burgundy-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/pink-zebra-stripes-in-burgundy-panel.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--smile-repeated-warped-terracotta-lettering",
    "name": "Smile Repeated Warped Terracotta Lettering",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/smile-repeated-warped-terracotta-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/smile-repeated-warped-terracotta-lettering.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-bold-brush-loops-on-cream",
    "name": "Terracotta Bold Brush Loops On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-bold-brush-loops-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-bold-brush-loops-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-brush-dash-pattern-on-pink",
    "name": "Terracotta Brush Dash Pattern On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-brush-dash-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-brush-dash-pattern-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-curved-parallel-lines-with-circles",
    "name": "Terracotta Curved Parallel Lines With Circles",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-curved-parallel-lines-with-circles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-curved-parallel-lines-with-circles.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-curved-stripe-panel-on-cream",
    "name": "Terracotta Curved Stripe Panel On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-curved-stripe-panel-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-curved-stripe-panel-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-dotted-face-profile-on-cream",
    "name": "Terracotta Dotted Face Profile On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-dotted-face-profile-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-dotted-face-profile-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-five-prong-shape-on-pink",
    "name": "Terracotta Five Prong Shape On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-five-prong-shape-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-five-prong-shape-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-intersecting-sketch-lines-on-pink",
    "name": "Terracotta Intersecting Sketch Lines On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-intersecting-sketch-lines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-intersecting-sketch-lines-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-marbled-waves-on-pink",
    "name": "Terracotta Marbled Waves On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-marbled-waves-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-marbled-waves-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-overlapping-angular-loops-on-cream",
    "name": "Terracotta Overlapping Angular Loops On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-overlapping-angular-loops-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-overlapping-angular-loops-on-cream.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-radial-line-burst-on-pink",
    "name": "Terracotta Radial Line Burst On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-radial-line-burst-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-radial-line-burst-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-rose-outline-pattern",
    "name": "Terracotta Rose Outline Pattern",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-rose-outline-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-rose-outline-pattern.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-star-and-cream-squiggle-on-pink",
    "name": "Terracotta Star And Cream Squiggle On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-star-and-cream-squiggle-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-star-and-cream-squiggle-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-thick-brush-swirls-on-pink",
    "name": "Terracotta Thick Brush Swirls On Pink",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-thick-brush-swirls-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-thick-brush-swirls-on-pink.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--terracotta-tulip-brush-drawing",
    "name": "Terracotta Tulip Brush Drawing",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/terracotta-tulip-brush-drawing.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/terracotta-tulip-brush-drawing.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--two-cream-vertical-striped-circles-on-terracotta",
    "name": "Two Cream Vertical Striped Circles On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/two-cream-vertical-striped-circles-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/two-cream-vertical-striped-circles-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--two-pink-heart-outlines-on-terracotta",
    "name": "Two Pink Heart Outlines On Terracotta",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/two-pink-heart-outlines-on-terracotta.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/two-pink-heart-outlines-on-terracotta.jpg")
  },
  {
    "id": "mid-century-modern-pink-red--two-terracotta-spirals-on-cream",
    "name": "Two Terracotta Spirals On Cream",
    "category": "Mid Century Modern Pink Red",
    "src": window.StrayzyAsset("./assets/background-patterns/mid-century-modern-pink-red/two-terracotta-spirals-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/mid-century-modern-pink-red/two-terracotta-spirals-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--black-cherry-bow-in-wavy-frame",
    "name": "Black Cherry Bow In Wavy Frame",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-cherry-bow-in-wavy-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-cherry-bow-in-wavy-frame.jpg")
  },
  {
    "id": "pink-blue-y2k--black-cherry-cocktail-with-ribbon-bow",
    "name": "Black Cherry Cocktail With Ribbon Bow",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-cherry-cocktail-with-ribbon-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-cherry-cocktail-with-ribbon-bow.jpg")
  },
  {
    "id": "pink-blue-y2k--black-drooping-flower-outline-on-blue",
    "name": "Black Drooping Flower Outline On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-drooping-flower-outline-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-drooping-flower-outline-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--black-fern-branch-on-pastel-blue",
    "name": "Black Fern Branch On Pastel Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-fern-branch-on-pastel-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-fern-branch-on-pastel-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--black-heart-tic-tac-toe-on-blue",
    "name": "Black Heart Tic Tac Toe On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-heart-tic-tac-toe-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-heart-tic-tac-toe-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--black-thick-curved-lines-on-cream",
    "name": "Black Thick Curved Lines On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-thick-curved-lines-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-thick-curved-lines-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--black-white-checkerboard-heart-on-pink",
    "name": "Black White Checkerboard Heart On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-white-checkerboard-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-white-checkerboard-heart-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--black-white-halftone-orchid-on-pink",
    "name": "Black White Halftone Orchid On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/black-white-halftone-orchid-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/black-white-halftone-orchid-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--celebrate-yourself-heart-shaped-cake",
    "name": "Celebrate Yourself Heart Shaped Cake",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/celebrate-yourself-heart-shaped-cake.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/celebrate-yourself-heart-shaped-cake.jpg")
  },
  {
    "id": "pink-blue-y2k--clear-gummy-bear-on-pastel-blue",
    "name": "Clear Gummy Bear On Pastel Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/clear-gummy-bear-on-pastel-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/clear-gummy-bear-on-pastel-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-abstract-floral-shapes-on-blue",
    "name": "Cream Abstract Floral Shapes On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-abstract-floral-shapes-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-abstract-floral-shapes-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-eye-grid-on-hot-pink",
    "name": "Cream Eye Grid On Hot Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-eye-grid-on-hot-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-eye-grid-on-hot-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-flower-black-leaves-on-pink",
    "name": "Cream Flower Black Leaves On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-flower-black-leaves-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-flower-black-leaves-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-melting-smiley-on-blue",
    "name": "Cream Melting Smiley On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-melting-smiley-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-melting-smiley-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-organic-spiral-on-pastel-blue",
    "name": "Cream Organic Spiral On Pastel Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-organic-spiral-on-pastel-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-organic-spiral-on-pastel-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-seated-figure-on-hot-pink",
    "name": "Cream Seated Figure On Hot Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-seated-figure-on-hot-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-seated-figure-on-hot-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--cream-sun-and-wavy-rays-on-pink",
    "name": "Cream Sun And Wavy Rays On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cream-sun-and-wavy-rays-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cream-sun-and-wavy-rays-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--cropped-pink-eight-ball-on-cream",
    "name": "Cropped Pink Eight Ball On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/cropped-pink-eight-ball-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/cropped-pink-eight-ball-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--dripping-silver-chain-links",
    "name": "Dripping Silver Chain Links",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/dripping-silver-chain-links.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/dripping-silver-chain-links.jpg")
  },
  {
    "id": "pink-blue-y2k--focus-on-the-good-black-script-on-blue",
    "name": "Focus On The Good Black Script On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/focus-on-the-good-black-script-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/focus-on-the-good-black-script-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--four-black-dancing-skeletons-on-pink",
    "name": "Four Black Dancing Skeletons On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/four-black-dancing-skeletons-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/four-black-dancing-skeletons-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--glossy-pink-heart-lollipop-on-blue",
    "name": "Glossy Pink Heart Lollipop On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/glossy-pink-heart-lollipop-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/glossy-pink-heart-lollipop-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--iridescent-liquid-bubbles-on-pink",
    "name": "Iridescent Liquid Bubbles On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/iridescent-liquid-bubbles-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/iridescent-liquid-bubbles-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--loving-myself-is-my-favorite-routine",
    "name": "Loving Myself Is My Favorite Routine",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/loving-myself-is-my-favorite-routine.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/loving-myself-is-my-favorite-routine.jpg")
  },
  {
    "id": "pink-blue-y2k--main-character-energy-halftone-orchid",
    "name": "Main Character Energy Halftone Orchid",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/main-character-energy-halftone-orchid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/main-character-energy-halftone-orchid.jpg")
  },
  {
    "id": "pink-blue-y2k--melting-silver-heart-on-pastel-blue",
    "name": "Melting Silver Heart On Pastel Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/melting-silver-heart-on-pastel-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/melting-silver-heart-on-pastel-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--metallic-purple-heart-with-orbit-rings",
    "name": "Metallic Purple Heart With Orbit Rings",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/metallic-purple-heart-with-orbit-rings.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/metallic-purple-heart-with-orbit-rings.jpg")
  },
  {
    "id": "pink-blue-y2k--my-energy-is-sacred-pink-aura",
    "name": "My Energy Is Sacred Pink Aura",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/my-energy-is-sacred-pink-aura.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/my-energy-is-sacred-pink-aura.jpg")
  },
  {
    "id": "pink-blue-y2k--nine-silver-metallic-flowers-on-pink",
    "name": "Nine Silver Metallic Flowers On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/nine-silver-metallic-flowers-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/nine-silver-metallic-flowers-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--pink-bloom-black-flowing-leaves",
    "name": "Pink Bloom Black Flowing Leaves",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/pink-bloom-black-flowing-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/pink-bloom-black-flowing-leaves.jpg")
  },
  {
    "id": "pink-blue-y2k--pink-daisies-on-blue-warped-checkerboard",
    "name": "Pink Daisies On Blue Warped Checkerboard",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/pink-daisies-on-blue-warped-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/pink-daisies-on-blue-warped-checkerboard.jpg")
  },
  {
    "id": "pink-blue-y2k--pink-drooping-abstract-petals-on-cream",
    "name": "Pink Drooping Abstract Petals On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/pink-drooping-abstract-petals-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/pink-drooping-abstract-petals-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--rhinestone-cherries-and-bow-on-blue",
    "name": "Rhinestone Cherries And Bow On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/rhinestone-cherries-and-bow-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/rhinestone-cherries-and-bow-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--rhinestone-musical-notes-on-cream",
    "name": "Rhinestone Musical Notes On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/rhinestone-musical-notes-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/rhinestone-musical-notes-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--silver-disco-ball-on-hot-pink",
    "name": "Silver Disco Ball On Hot Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/silver-disco-ball-on-hot-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/silver-disco-ball-on-hot-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--silver-inflated-love-letters-on-cream",
    "name": "Silver Inflated Love Letters On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/silver-inflated-love-letters-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/silver-inflated-love-letters-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--solid-pink-heart-on-cream",
    "name": "Solid Pink Heart On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/solid-pink-heart-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/solid-pink-heart-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--three-cream-daisies-black-stems-on-blue",
    "name": "Three Cream Daisies Black Stems On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/three-cream-daisies-black-stems-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/three-cream-daisies-black-stems-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--three-cream-propeller-flowers-on-blue",
    "name": "Three Cream Propeller Flowers On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/three-cream-propeller-flowers-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/three-cream-propeller-flowers-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--three-pink-tulips-white-leaves-on-blue",
    "name": "Three Pink Tulips White Leaves On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/three-pink-tulips-white-leaves-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/three-pink-tulips-white-leaves-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--two-black-and-white-eyes-on-cream",
    "name": "Two Black And White Eyes On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-black-and-white-eyes-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-black-and-white-eyes-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--two-black-halftone-lips-on-cream",
    "name": "Two Black Halftone Lips On Cream",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-black-halftone-lips-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-black-halftone-lips-on-cream.jpg")
  },
  {
    "id": "pink-blue-y2k--two-black-halftone-stars-on-pink",
    "name": "Two Black Halftone Stars On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-black-halftone-stars-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-black-halftone-stars-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--two-chrome-sparkles-pink-glow",
    "name": "Two Chrome Sparkles Pink Glow",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-chrome-sparkles-pink-glow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-chrome-sparkles-pink-glow.jpg")
  },
  {
    "id": "pink-blue-y2k--two-cream-tulips-on-pink",
    "name": "Two Cream Tulips On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-cream-tulips-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-cream-tulips-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--two-pink-wireframe-hearts",
    "name": "Two Pink Wireframe Hearts",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-pink-wireframe-hearts.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-pink-wireframe-hearts.jpg")
  },
  {
    "id": "pink-blue-y2k--two-white-daisies-black-leaves-on-blue",
    "name": "Two White Daisies Black Leaves On Blue",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/two-white-daisies-black-leaves-on-blue.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/two-white-daisies-black-leaves-on-blue.jpg")
  },
  {
    "id": "pink-blue-y2k--white-love-lettering-pattern-on-pink",
    "name": "White Love Lettering Pattern On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/white-love-lettering-pattern-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/white-love-lettering-pattern-on-pink.jpg")
  },
  {
    "id": "pink-blue-y2k--white-teddy-bear-with-pink-heart-and-bow",
    "name": "White Teddy Bear With Pink Heart And Bow",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/white-teddy-bear-with-pink-heart-and-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/white-teddy-bear-with-pink-heart-and-bow.jpg")
  },
  {
    "id": "pink-blue-y2k--you-are-loved-cream-script-on-pink",
    "name": "You Are Loved Cream Script On Pink",
    "category": "Pink Blue Y2K",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-blue-y2k/you-are-loved-cream-script-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-blue-y2k/you-are-loved-cream-script-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--cream-abstract-tulip-cutout-on-green",
    "name": "Cream Abstract Tulip Cutout On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-abstract-tulip-cutout-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-abstract-tulip-cutout-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--cream-bloom-with-flowing-green-leaves-on-pink",
    "name": "Cream Bloom With Flowing Green Leaves On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-bloom-with-flowing-green-leaves-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-bloom-with-flowing-green-leaves-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--cream-crescent-moon-on-green",
    "name": "Cream Crescent Moon On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-crescent-moon-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-crescent-moon-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--cream-flower-cutouts-pink-centers-on-green",
    "name": "Cream Flower Cutouts Pink Centers On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-flower-cutouts-pink-centers-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-flower-cutouts-pink-centers-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--cream-jellyfish-green-bell-on-pink",
    "name": "Cream Jellyfish Green Bell On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-jellyfish-green-bell-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-jellyfish-green-bell-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--cream-stag-beetle-illustration-on-green",
    "name": "Cream Stag Beetle Illustration On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/cream-stag-beetle-illustration-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/cream-stag-beetle-illustration-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--curved-green-leaf-with-long-stem",
    "name": "Curved Green Leaf With Long Stem",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/curved-green-leaf-with-long-stem.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/curved-green-leaf-with-long-stem.jpg")
  },
  {
    "id": "pink-green-botanical--dark-green-arrowhead-leaf-on-pink",
    "name": "Dark Green Arrowhead Leaf On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/dark-green-arrowhead-leaf-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/dark-green-arrowhead-leaf-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--dark-green-heart-shaped-leaf-on-pink",
    "name": "Dark Green Heart Shaped Leaf On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/dark-green-heart-shaped-leaf-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/dark-green-heart-shaped-leaf-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--dark-green-veined-oval-leaf",
    "name": "Dark Green Veined Oval Leaf",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/dark-green-veined-oval-leaf.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/dark-green-veined-oval-leaf.jpg")
  },
  {
    "id": "pink-green-botanical--four-cream-heart-outlines-on-green",
    "name": "Four Cream Heart Outlines On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/four-cream-heart-outlines-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/four-cream-heart-outlines-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--four-green-organic-pebbles-on-cream",
    "name": "Four Green Organic Pebbles On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/four-green-organic-pebbles-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/four-green-organic-pebbles-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--four-pink-tulips-on-cream",
    "name": "Four Pink Tulips On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/four-pink-tulips-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/four-pink-tulips-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--good-vibes-only-green-script-on-pink",
    "name": "Good Vibes Only Green Script On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/good-vibes-only-green-script-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/good-vibes-only-green-script-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--green-abstract-eye-and-nose-on-cream",
    "name": "Green Abstract Eye And Nose On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-abstract-eye-and-nose-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-abstract-eye-and-nose-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--green-abstract-petals-in-opposite-corners",
    "name": "Green Abstract Petals In Opposite Corners",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-abstract-petals-in-opposite-corners.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-abstract-petals-in-opposite-corners.jpg")
  },
  {
    "id": "pink-green-botanical--green-curved-diamond-lattice-on-pink",
    "name": "Green Curved Diamond Lattice On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-curved-diamond-lattice-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-curved-diamond-lattice-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--green-deeply-lobed-leaf-on-cream",
    "name": "Green Deeply Lobed Leaf On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-deeply-lobed-leaf-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-deeply-lobed-leaf-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--green-long-ribbon-bow-on-pink",
    "name": "Green Long Ribbon Bow On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-long-ribbon-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-long-ribbon-bow-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--green-organic-splash-shapes-on-pink",
    "name": "Green Organic Splash Shapes On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-organic-splash-shapes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-organic-splash-shapes-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--green-palm-tree-silhouette-on-cream",
    "name": "Green Palm Tree Silhouette On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-palm-tree-silhouette-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-palm-tree-silhouette-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--green-spotted-leaf-branch-on-cream",
    "name": "Green Spotted Leaf Branch On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-spotted-leaf-branch-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-spotted-leaf-branch-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--green-swirling-leafy-branches-on-cream",
    "name": "Green Swirling Leafy Branches On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/green-swirling-leafy-branches-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/green-swirling-leafy-branches-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--hello-cream-daisy-on-pink",
    "name": "Hello Cream Daisy On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/hello-cream-daisy-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/hello-cream-daisy-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--hello-spring-cream-script-on-green",
    "name": "Hello Spring Cream Script On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/hello-spring-cream-script-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/hello-spring-cream-script-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--large-green-split-leaf-on-cream",
    "name": "Large Green Split Leaf On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/large-green-split-leaf-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/large-green-split-leaf-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--mirrored-cream-pink-flowers-on-green",
    "name": "Mirrored Cream Pink Flowers On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/mirrored-cream-pink-flowers-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/mirrored-cream-pink-flowers-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--mirrored-pink-long-stem-flowers-on-green",
    "name": "Mirrored Pink Long Stem Flowers On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/mirrored-pink-long-stem-flowers-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/mirrored-pink-long-stem-flowers-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--pink-abstract-leaf-on-dark-green",
    "name": "Pink Abstract Leaf On Dark Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-abstract-leaf-on-dark-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-abstract-leaf-on-dark-green.jpg")
  },
  {
    "id": "pink-green-botanical--pink-flower-in-cream-panel-green-frame",
    "name": "Pink Flower In Cream Panel Green Frame",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-flower-in-cream-panel-green-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-flower-in-cream-panel-green-frame.jpg")
  },
  {
    "id": "pink-green-botanical--pink-flowing-vertical-stripes-on-cream",
    "name": "Pink Flowing Vertical Stripes On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-flowing-vertical-stripes-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-flowing-vertical-stripes-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--pink-heart-with-green-outline-on-cream",
    "name": "Pink Heart With Green Outline On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-heart-with-green-outline-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-heart-with-green-outline-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--pink-leaf-cutout-pattern-on-green",
    "name": "Pink Leaf Cutout Pattern On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-leaf-cutout-pattern-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-leaf-cutout-pattern-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--pink-love-lettering-pattern-on-green",
    "name": "Pink Love Lettering Pattern On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-love-lettering-pattern-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-love-lettering-pattern-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--pink-organic-oval-shapes-on-green",
    "name": "Pink Organic Oval Shapes On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-organic-oval-shapes-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-organic-oval-shapes-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--pink-organic-spiral-on-green",
    "name": "Pink Organic Spiral On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/pink-organic-spiral-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/pink-organic-spiral-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--this-will-pass-green-lettering-on-pink",
    "name": "This Will Pass Green Lettering On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/this-will-pass-green-lettering-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/this-will-pass-green-lettering-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--three-cream-daisies-black-centers-on-pink",
    "name": "Three Cream Daisies Black Centers On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/three-cream-daisies-black-centers-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/three-cream-daisies-black-centers-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--three-cream-rounded-flowers-on-green",
    "name": "Three Cream Rounded Flowers On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/three-cream-rounded-flowers-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/three-cream-rounded-flowers-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--three-green-patterned-butterflies",
    "name": "Three Green Patterned Butterflies",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/three-green-patterned-butterflies.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/three-green-patterned-butterflies.jpg")
  },
  {
    "id": "pink-green-botanical--three-stacked-green-geometric-shapes-on-pink",
    "name": "Three Stacked Green Geometric Shapes On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/three-stacked-green-geometric-shapes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/three-stacked-green-geometric-shapes-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--two-cream-flying-birds-on-pink",
    "name": "Two Cream Flying Birds On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-cream-flying-birds-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-cream-flying-birds-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--two-cream-irregular-rings-on-green",
    "name": "Two Cream Irregular Rings On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-cream-irregular-rings-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-cream-irregular-rings-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--two-cream-outline-spirals-on-green",
    "name": "Two Cream Outline Spirals On Green",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-cream-outline-spirals-on-green.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-cream-outline-spirals-on-green.jpg")
  },
  {
    "id": "pink-green-botanical--two-elongated-dark-green-leaves-on-cream",
    "name": "Two Elongated Dark Green Leaves On Cream",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-elongated-dark-green-leaves-on-cream.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-elongated-dark-green-leaves-on-cream.jpg")
  },
  {
    "id": "pink-green-botanical--two-green-floral-cutouts-on-pink",
    "name": "Two Green Floral Cutouts On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-green-floral-cutouts-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-green-floral-cutouts-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--two-green-speckled-mushrooms",
    "name": "Two Green Speckled Mushrooms",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-green-speckled-mushrooms.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-green-speckled-mushrooms.jpg")
  },
  {
    "id": "pink-green-botanical--two-pink-blooms-on-curling-green-stem",
    "name": "Two Pink Blooms On Curling Green Stem",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-pink-blooms-on-curling-green-stem.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-pink-blooms-on-curling-green-stem.jpg")
  },
  {
    "id": "pink-green-botanical--two-variegated-green-leaves-on-pink",
    "name": "Two Variegated Green Leaves On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/two-variegated-green-leaves-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/two-variegated-green-leaves-on-pink.jpg")
  },
  {
    "id": "pink-green-botanical--variegated-green-white-leafy-sprig-on-pink",
    "name": "Variegated Green White Leafy Sprig On Pink",
    "category": "Pink Green Botanical",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-green-botanical/variegated-green-white-leafy-sprig-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-green-botanical/variegated-green-white-leafy-sprig-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--balance-walking-leopard",
    "name": "Balance Walking Leopard",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/balance-walking-leopard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/balance-walking-leopard.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-brush-heart-outline-on-pink",
    "name": "Black Brush Heart Outline On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-brush-heart-outline-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-brush-heart-outline-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-cherry-with-ribbon-bow-on-pink",
    "name": "Black Cherry With Ribbon Bow On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-cherry-with-ribbon-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-cherry-with-ribbon-bow-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-cowboy-boot-with-white-stars",
    "name": "Black Cowboy Boot With White Stars",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-cowboy-boot-with-white-stars.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-cowboy-boot-with-white-stars.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-eight-ball-leopard-777-on-pink",
    "name": "Black Eight Ball Leopard 777 On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-eight-ball-leopard-777-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-eight-ball-leopard-777-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-inflated-xoxo-letters",
    "name": "Black Inflated Xoxo Letters",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-inflated-xoxo-letters.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-inflated-xoxo-letters.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-monstera-leaf-on-pink",
    "name": "Black Monstera Leaf On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-monstera-leaf-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-monstera-leaf-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-rough-vertical-stripes-on-pink",
    "name": "Black Rough Vertical Stripes On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-rough-vertical-stripes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-rough-vertical-stripes-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-white-organic-spiral",
    "name": "Black White Organic Spiral",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-white-organic-spiral.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-white-organic-spiral.jpg")
  },
  {
    "id": "pink-leopard-coquette--black-white-seated-leopard-on-pink",
    "name": "Black White Seated Leopard On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/black-white-seated-leopard-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/black-white-seated-leopard-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--cin-cin-two-pink-cocktails",
    "name": "Cin Cin Two Pink Cocktails",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/cin-cin-two-pink-cocktails.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/cin-cin-two-pink-cocktails.jpg")
  },
  {
    "id": "pink-leopard-coquette--cool-people-live-here-black-white-on-pink",
    "name": "Cool People Live Here Black White On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/cool-people-live-here-black-white-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/cool-people-live-here-black-white-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--cropped-pink-eight-ball-on-black",
    "name": "Cropped Pink Eight Ball On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/cropped-pink-eight-ball-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/cropped-pink-eight-ball-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--do-more-of-what-you-love-black-red",
    "name": "Do More Of What You Love Black Red",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/do-more-of-what-you-love-black-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/do-more-of-what-you-love-black-red.jpg")
  },
  {
    "id": "pink-leopard-coquette--everything-works-out-for-me-pink-aura",
    "name": "Everything Works Out For Me Pink Aura",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/everything-works-out-for-me-pink-aura.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/everything-works-out-for-me-pink-aura.jpg")
  },
  {
    "id": "pink-leopard-coquette--flower-black-tulips-in-pink-panel",
    "name": "Flower Black Tulips In Pink Panel",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/flower-black-tulips-in-pink-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/flower-black-tulips-in-pink-panel.jpg")
  },
  {
    "id": "pink-leopard-coquette--glossy-curved-pink-heart",
    "name": "Glossy Curved Pink Heart",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/glossy-curved-pink-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/glossy-curved-pink-heart.jpg")
  },
  {
    "id": "pink-leopard-coquette--good-luck-white-script-on-black",
    "name": "Good Luck White Script On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/good-luck-white-script-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/good-luck-white-script-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--je-taime-repeated-pink-on-black",
    "name": "Je Taime Repeated Pink On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/je-taime-repeated-pink-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/je-taime-repeated-pink-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--leopard-print-eight-ball-on-black",
    "name": "Leopard Print Eight Ball On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/leopard-print-eight-ball-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/leopard-print-eight-ball-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--leopard-print-five-point-star-on-pink",
    "name": "Leopard Print Five Point Star On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/leopard-print-five-point-star-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/leopard-print-five-point-star-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--leopard-print-heart-on-pink",
    "name": "Leopard Print Heart On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/leopard-print-heart-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/leopard-print-heart-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--leopard-print-lightning-bolt",
    "name": "Leopard Print Lightning Bolt",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/leopard-print-lightning-bolt.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/leopard-print-lightning-bolt.jpg")
  },
  {
    "id": "pink-leopard-coquette--love-you-pink-script-on-black",
    "name": "Love You Pink Script On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/love-you-pink-script-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/love-you-pink-script-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--lucky-billiard-ball-cherries-with-bow",
    "name": "Lucky Billiard Ball Cherries With Bow",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/lucky-billiard-ball-cherries-with-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/lucky-billiard-ball-cherries-with-bow.jpg")
  },
  {
    "id": "pink-leopard-coquette--lucky-you-king-of-hearts-card",
    "name": "Lucky You King Of Hearts Card",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/lucky-you-king-of-hearts-card.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/lucky-you-king-of-hearts-card.jpg")
  },
  {
    "id": "pink-leopard-coquette--make-your-own-magic-pink-on-black",
    "name": "Make Your Own Magic Pink On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/make-your-own-magic-pink-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/make-your-own-magic-pink-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--more-soul-black-stacked-lettering",
    "name": "More Soul Black Stacked Lettering",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/more-soul-black-stacked-lettering.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/more-soul-black-stacked-lettering.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-abstract-radial-flower",
    "name": "Pink Abstract Radial Flower",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-abstract-radial-flower.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-abstract-radial-flower.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-bell-flowers-black-stems",
    "name": "Pink Bell Flowers Black Stems",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-bell-flowers-black-stems.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-bell-flowers-black-stems.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-black-warped-checkerboard",
    "name": "Pink Black Warped Checkerboard",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-black-warped-checkerboard.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-black-warped-checkerboard.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-brush-heart-pattern-on-black",
    "name": "Pink Brush Heart Pattern On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-brush-heart-pattern-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-brush-heart-pattern-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-fuzzy-love-letters",
    "name": "Pink Fuzzy Love Letters",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-fuzzy-love-letters.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-fuzzy-love-letters.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-line-cactus-on-black",
    "name": "Pink Line Cactus On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-line-cactus-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-line-cactus-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-paw-print-on-black",
    "name": "Pink Paw Print On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-paw-print-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-paw-print-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--pink-white-striped-bow-on-black",
    "name": "Pink White Striped Bow On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/pink-white-striped-bow-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/pink-white-striped-bow-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--seated-golden-leopard-on-pink",
    "name": "Seated Golden Leopard On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/seated-golden-leopard-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/seated-golden-leopard-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--silver-disco-ball-on-pastel-pink",
    "name": "Silver Disco Ball On Pastel Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/silver-disco-ball-on-pastel-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/silver-disco-ball-on-pastel-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--sixteen-red-hearts-on-pink",
    "name": "Sixteen Red Hearts On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/sixteen-red-hearts-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/sixteen-red-hearts-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--take-the-risk-white-smiley-on-black",
    "name": "Take The Risk White Smiley On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/take-the-risk-white-smiley-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/take-the-risk-white-smiley-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--tan-black-leopard-spots-on-pink",
    "name": "Tan Black Leopard Spots On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/tan-black-leopard-spots-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/tan-black-leopard-spots-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--three-black-white-leopard-print-stars",
    "name": "Three Black White Leopard Print Stars",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/three-black-white-leopard-print-stars.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/three-black-white-leopard-print-stars.jpg")
  },
  {
    "id": "pink-leopard-coquette--three-pink-scribbled-hearts-on-black",
    "name": "Three Pink Scribbled Hearts On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/three-pink-scribbled-hearts-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/three-pink-scribbled-hearts-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--three-white-sparkles-on-black",
    "name": "Three White Sparkles On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/three-white-sparkles-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/three-white-sparkles-on-black.jpg")
  },
  {
    "id": "pink-leopard-coquette--true-love-pink-lettering-pattern",
    "name": "True Love Pink Lettering Pattern",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/true-love-pink-lettering-pattern.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/true-love-pink-lettering-pattern.jpg")
  },
  {
    "id": "pink-leopard-coquette--two-black-butterflies-on-pink",
    "name": "Two Black Butterflies On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/two-black-butterflies-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/two-black-butterflies-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--two-black-heart-dice-on-white",
    "name": "Two Black Heart Dice On White",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/two-black-heart-dice-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/two-black-heart-dice-on-white.jpg")
  },
  {
    "id": "pink-leopard-coquette--two-black-lipstick-kisses-on-pink",
    "name": "Two Black Lipstick Kisses On Pink",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/two-black-lipstick-kisses-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/two-black-lipstick-kisses-on-pink.jpg")
  },
  {
    "id": "pink-leopard-coquette--two-leopard-print-lips",
    "name": "Two Leopard Print Lips",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/two-leopard-print-lips.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/two-leopard-print-lips.jpg")
  },
  {
    "id": "pink-leopard-coquette--white-rhinestone-heart-on-black",
    "name": "White Rhinestone Heart On Black",
    "category": "Pink Leopard Coquette",
    "src": window.StrayzyAsset("./assets/background-patterns/pink-leopard-coquette/white-rhinestone-heart-on-black.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink-leopard-coquette/white-rhinestone-heart-on-black.jpg")
  },
  {
    "id": "pink--black-billiard-eight-ball-on-pink",
    "name": "Black Billiard Eight Ball On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/black-billiard-eight-ball-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/black-billiard-eight-ball-on-pink.jpg")
  },
  {
    "id": "pink--black-eyelash-eye-grid-on-pink",
    "name": "Black Eyelash Eye Grid On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/black-eyelash-eye-grid-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/black-eyelash-eye-grid-on-pink.jpg")
  },
  {
    "id": "pink--black-halftone-lips-in-rounded-panel",
    "name": "Black Halftone Lips In Rounded Panel",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/black-halftone-lips-in-rounded-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/black-halftone-lips-in-rounded-panel.jpg")
  },
  {
    "id": "pink--bloom-three-pink-flowers",
    "name": "Bloom Three Pink Flowers",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/bloom-three-pink-flowers.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/bloom-three-pink-flowers.jpg")
  },
  {
    "id": "pink--burgundy-anatomical-heart-drawing-on-pink",
    "name": "Burgundy Anatomical Heart Drawing On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/burgundy-anatomical-heart-drawing-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/burgundy-anatomical-heart-drawing-on-pink.jpg")
  },
  {
    "id": "pink--burgundy-coupe-glass-with-bow-on-pink",
    "name": "Burgundy Coupe Glass With Bow On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/burgundy-coupe-glass-with-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/burgundy-coupe-glass-with-bow-on-pink.jpg")
  },
  {
    "id": "pink--burgundy-satin-ribbon-bow-on-pink",
    "name": "Burgundy Satin Ribbon Bow On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/burgundy-satin-ribbon-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/burgundy-satin-ribbon-bow-on-pink.jpg")
  },
  {
    "id": "pink--clear-gummy-bear-iridescent-pink-background",
    "name": "Clear Gummy Bear Iridescent Pink Background",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/clear-gummy-bear-iridescent-pink-background.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/clear-gummy-bear-iridescent-pink-background.jpg")
  },
  {
    "id": "pink--decorated-cake-on-pedestal-red-line-art",
    "name": "Decorated Cake On Pedestal Red Line Art",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/decorated-cake-on-pedestal-red-line-art.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/decorated-cake-on-pedestal-red-line-art.jpg")
  },
  {
    "id": "pink--dont-tell-me-what-to-do-black-lips",
    "name": "Dont Tell Me What To Do Black Lips",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/dont-tell-me-what-to-do-black-lips.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/dont-tell-me-what-to-do-black-lips.jpg")
  },
  {
    "id": "pink--energy-speaks-first-glowing-pink-star",
    "name": "Energy Speaks First Glowing Pink Star",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/energy-speaks-first-glowing-pink-star.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/energy-speaks-first-glowing-pink-star.jpg")
  },
  {
    "id": "pink--everything-looks-better-in-pink-orbit-heart",
    "name": "Everything Looks Better In Pink Orbit Heart",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/everything-looks-better-in-pink-orbit-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/everything-looks-better-in-pink-orbit-heart.jpg")
  },
  {
    "id": "pink--glowing-white-heart-pink-aura",
    "name": "Glowing White Heart Pink Aura",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/glowing-white-heart-pink-aura.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/glowing-white-heart-pink-aura.jpg")
  },
  {
    "id": "pink--hot-pink-evil-eye-in-white-panel",
    "name": "Hot Pink Evil Eye In White Panel",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/hot-pink-evil-eye-in-white-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/hot-pink-evil-eye-in-white-panel.jpg")
  },
  {
    "id": "pink--i-attract-better-black-orbit-sparkles",
    "name": "I Attract Better Black Orbit Sparkles",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-attract-better-black-orbit-sparkles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-attract-better-black-orbit-sparkles.jpg")
  },
  {
    "id": "pink--i-believe-in-me-tiny-white-blossoms",
    "name": "I Believe In Me Tiny White Blossoms",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-believe-in-me-tiny-white-blossoms.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-believe-in-me-tiny-white-blossoms.jpg")
  },
  {
    "id": "pink--i-deserve-everything-dark-orchid",
    "name": "I Deserve Everything Dark Orchid",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-deserve-everything-dark-orchid.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-deserve-everything-dark-orchid.jpg")
  },
  {
    "id": "pink--i-deserve-more-zebra-striped-star",
    "name": "I Deserve More Zebra Striped Star",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-deserve-more-zebra-striped-star.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-deserve-more-zebra-striped-star.jpg")
  },
  {
    "id": "pink--i-do-it-for-me-burgundy-stars",
    "name": "I Do It For Me Burgundy Stars",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-do-it-for-me-burgundy-stars.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-do-it-for-me-burgundy-stars.jpg")
  },
  {
    "id": "pink--i-get-everything-i-want-black-butterfly",
    "name": "I Get Everything I Want Black Butterfly",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-get-everything-i-want-black-butterfly.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-get-everything-i-want-black-butterfly.jpg")
  },
  {
    "id": "pink--i-respect-my-energy-pink-halftone-star",
    "name": "I Respect My Energy Pink Halftone Star",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-respect-my-energy-pink-halftone-star.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-respect-my-energy-pink-halftone-star.jpg")
  },
  {
    "id": "pink--i-trust-my-intuition-black-script",
    "name": "I Trust My Intuition Black Script",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/i-trust-my-intuition-black-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/i-trust-my-intuition-black-script.jpg")
  },
  {
    "id": "pink--im-not-the-same-silver-star",
    "name": "Im Not The Same Silver Star",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/im-not-the-same-silver-star.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/im-not-the-same-silver-star.jpg")
  },
  {
    "id": "pink--kiss-me-now-black-script-on-pink",
    "name": "Kiss Me Now Black Script On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/kiss-me-now-black-script-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/kiss-me-now-black-script-on-pink.jpg")
  },
  {
    "id": "pink--leopard-print-star-on-pink",
    "name": "Leopard Print Star On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/leopard-print-star-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/leopard-print-star-on-pink.jpg")
  },
  {
    "id": "pink--love-silver-chain-heart",
    "name": "Love Silver Chain Heart",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/love-silver-chain-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/love-silver-chain-heart.jpg")
  },
  {
    "id": "pink--love-white-block-letters-on-pink",
    "name": "Love White Block Letters On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/love-white-block-letters-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/love-white-block-letters-on-pink.jpg")
  },
  {
    "id": "pink--pink-please-butterfly-silhouette",
    "name": "Pink Please Butterfly Silhouette",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/pink-please-butterfly-silhouette.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/pink-please-butterfly-silhouette.jpg")
  },
  {
    "id": "pink--pure-intention-dark-cherries",
    "name": "Pure Intention Dark Cherries",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/pure-intention-dark-cherries.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/pure-intention-dark-cherries.jpg")
  },
  {
    "id": "pink--red-glossy-lips-on-pale-pink",
    "name": "Red Glossy Lips On Pale Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/red-glossy-lips-on-pale-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/red-glossy-lips-on-pale-pink.jpg")
  },
  {
    "id": "pink--red-rose-in-oval-ribbon-frame",
    "name": "Red Rose In Oval Ribbon Frame",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/red-rose-in-oval-ribbon-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/red-rose-in-oval-ribbon-frame.jpg")
  },
  {
    "id": "pink--silver-balloon-dog-on-pale-pink",
    "name": "Silver Balloon Dog On Pale Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/silver-balloon-dog-on-pale-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/silver-balloon-dog-on-pale-pink.jpg")
  },
  {
    "id": "pink--silver-disco-ball-on-pale-pink",
    "name": "Silver Disco Ball On Pale Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/silver-disco-ball-on-pale-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/silver-disco-ball-on-pale-pink.jpg")
  },
  {
    "id": "pink--soft-glam-cherries-with-burgundy-satin-bow",
    "name": "Soft Glam Cherries With Burgundy Satin Bow",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/soft-glam-cherries-with-burgundy-satin-bow.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/soft-glam-cherries-with-burgundy-satin-bow.jpg")
  },
  {
    "id": "pink--sparkling-white-scallop-shell-on-pink",
    "name": "Sparkling White Scallop Shell On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/sparkling-white-scallop-shell-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/sparkling-white-scallop-shell-on-pink.jpg")
  },
  {
    "id": "pink--stay-pretty-laughing-cat",
    "name": "Stay Pretty Laughing Cat",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/stay-pretty-laughing-cat.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/stay-pretty-laughing-cat.jpg")
  },
  {
    "id": "pink--stay-soft-burgundy-wavy-frame-on-pink",
    "name": "Stay Soft Burgundy Wavy Frame On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/stay-soft-burgundy-wavy-frame-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/stay-soft-burgundy-wavy-frame-on-pink.jpg")
  },
  {
    "id": "pink--strawberries-and-lip-gloss-berry-drawing",
    "name": "Strawberries And Lip Gloss Berry Drawing",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/strawberries-and-lip-gloss-berry-drawing.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/strawberries-and-lip-gloss-berry-drawing.jpg")
  },
  {
    "id": "pink--three-black-halftone-sparkles-on-pink",
    "name": "Three Black Halftone Sparkles On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/three-black-halftone-sparkles-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/three-black-halftone-sparkles-on-pink.jpg")
  },
  {
    "id": "pink--three-metallic-heart-outlines-on-pink",
    "name": "Three Metallic Heart Outlines On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/three-metallic-heart-outlines-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/three-metallic-heart-outlines-on-pink.jpg")
  },
  {
    "id": "pink--two-detailed-black-eyes-on-pink",
    "name": "Two Detailed Black Eyes On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-detailed-black-eyes-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-detailed-black-eyes-on-pink.jpg")
  },
  {
    "id": "pink--two-glossy-red-dice-on-pink",
    "name": "Two Glossy Red Dice On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-glossy-red-dice-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-glossy-red-dice-on-pink.jpg")
  },
  {
    "id": "pink--two-hot-pink-butterfly-outlines",
    "name": "Two Hot Pink Butterfly Outlines",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-hot-pink-butterfly-outlines.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-hot-pink-butterfly-outlines.jpg")
  },
  {
    "id": "pink--two-leopard-print-lips-on-pink",
    "name": "Two Leopard Print Lips On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-leopard-print-lips-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-leopard-print-lips-on-pink.jpg")
  },
  {
    "id": "pink--two-metallic-pink-stars-with-white-waves",
    "name": "Two Metallic Pink Stars With White Waves",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-metallic-pink-stars-with-white-waves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-metallic-pink-stars-with-white-waves.jpg")
  },
  {
    "id": "pink--two-pink-macarons",
    "name": "Two Pink Macarons",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-pink-macarons.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-pink-macarons.jpg")
  },
  {
    "id": "pink--two-white-roses-on-pink",
    "name": "Two White Roses On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/two-white-roses-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/two-white-roses-on-pink.jpg")
  },
  {
    "id": "pink--walking-tiger-line-art-on-pink",
    "name": "Walking Tiger Line Art On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/walking-tiger-line-art-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/walking-tiger-line-art-on-pink.jpg")
  },
  {
    "id": "pink--white-pearl-bow-on-pink",
    "name": "White Pearl Bow On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/white-pearl-bow-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/white-pearl-bow-on-pink.jpg")
  },
  {
    "id": "pink--you-are-not-too-much-black-on-pink",
    "name": "You Are Not Too Much Black On Pink",
    "category": "Pink",
    "src": window.StrayzyAsset("./assets/background-patterns/pink/you-are-not-too-much-black-on-pink.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/pink/you-are-not-too-much-black-on-pink.jpg")
  },
  {
    "id": "red--ace-of-clubs-playing-card-on-red",
    "name": "Ace Of Clubs Playing Card On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/ace-of-clubs-playing-card-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/ace-of-clubs-playing-card-on-red.jpg")
  },
  {
    "id": "red--amour-mirrored-cream-script-on-red",
    "name": "Amour Mirrored Cream Script On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/amour-mirrored-cream-script-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/amour-mirrored-cream-script-on-red.jpg")
  },
  {
    "id": "red--babe-gold-metallic-script-on-red",
    "name": "Babe Gold Metallic Script On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/babe-gold-metallic-script-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/babe-gold-metallic-script-on-red.jpg")
  },
  {
    "id": "red--black-billiard-ball-red-heart-on-red",
    "name": "Black Billiard Ball Red Heart On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/black-billiard-ball-red-heart-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/black-billiard-ball-red-heart-on-red.jpg")
  },
  {
    "id": "red--black-billiard-eight-ball-on-white",
    "name": "Black Billiard Eight Ball On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/black-billiard-eight-ball-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/black-billiard-eight-ball-on-white.jpg")
  },
  {
    "id": "red--black-eight-ball-cherries-with-leaves",
    "name": "Black Eight Ball Cherries With Leaves",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/black-eight-ball-cherries-with-leaves.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/black-eight-ball-cherries-with-leaves.jpg")
  },
  {
    "id": "red--call-me-later-vintage-red-telephone",
    "name": "Call Me Later Vintage Red Telephone",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/call-me-later-vintage-red-telephone.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/call-me-later-vintage-red-telephone.jpg")
  },
  {
    "id": "red--celebrate-yourself-pink-heart-cake",
    "name": "Celebrate Yourself Pink Heart Cake",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/celebrate-yourself-pink-heart-cake.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/celebrate-yourself-pink-heart-cake.jpg")
  },
  {
    "id": "red--cheers-cat-with-sunglasses-and-cocktail",
    "name": "Cheers Cat With Sunglasses And Cocktail",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/cheers-cat-with-sunglasses-and-cocktail.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/cheers-cat-with-sunglasses-and-cocktail.jpg")
  },
  {
    "id": "red--cream-chalk-spiral-on-red",
    "name": "Cream Chalk Spiral On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/cream-chalk-spiral-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/cream-chalk-spiral-on-red.jpg")
  },
  {
    "id": "red--cream-heart-outline-on-red",
    "name": "Cream Heart Outline On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/cream-heart-outline-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/cream-heart-outline-on-red.jpg")
  },
  {
    "id": "red--cream-heart-tic-tac-toe-on-red",
    "name": "Cream Heart Tic Tac Toe On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/cream-heart-tic-tac-toe-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/cream-heart-tic-tac-toe-on-red.jpg")
  },
  {
    "id": "red--enjoy-life-white-script-with-sparkles",
    "name": "Enjoy Life White Script With Sparkles",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/enjoy-life-white-script-with-sparkles.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/enjoy-life-white-script-with-sparkles.jpg")
  },
  {
    "id": "red--feminine-energy-glitter-red-lips",
    "name": "Feminine Energy Glitter Red Lips",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/feminine-energy-glitter-red-lips.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/feminine-energy-glitter-red-lips.jpg")
  },
  {
    "id": "red--gold-disco-ball-on-red",
    "name": "Gold Disco Ball On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/gold-disco-ball-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/gold-disco-ball-on-red.jpg")
  },
  {
    "id": "red--gray-full-moon-on-white",
    "name": "Gray Full Moon On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/gray-full-moon-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/gray-full-moon-on-white.jpg")
  },
  {
    "id": "red--home-sweet-home-black-typography",
    "name": "Home Sweet Home Black Typography",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/home-sweet-home-black-typography.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/home-sweet-home-black-typography.jpg")
  },
  {
    "id": "red--honey-black-handwritten-script",
    "name": "Honey Black Handwritten Script",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/honey-black-handwritten-script.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/honey-black-handwritten-script.jpg")
  },
  {
    "id": "red--i-attract-everything-glowing-red-orb",
    "name": "I Attract Everything Glowing Red Orb",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/i-attract-everything-glowing-red-orb.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/i-attract-everything-glowing-red-orb.jpg")
  },
  {
    "id": "red--i-believe-in-myself-now-repeated-text",
    "name": "I Believe In Myself Now Repeated Text",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/i-believe-in-myself-now-repeated-text.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/i-believe-in-myself-now-repeated-text.jpg")
  },
  {
    "id": "red--i-choose-myself-black-butterfly",
    "name": "I Choose Myself Black Butterfly",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/i-choose-myself-black-butterfly.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/i-choose-myself-black-butterfly.jpg")
  },
  {
    "id": "red--leopard-fur-heart-on-white",
    "name": "Leopard Fur Heart On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/leopard-fur-heart-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/leopard-fur-heart-on-white.jpg")
  },
  {
    "id": "red--leopard-print-lightning-bolt-on-white",
    "name": "Leopard Print Lightning Bolt On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/leopard-print-lightning-bolt-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/leopard-print-lightning-bolt-on-white.jpg")
  },
  {
    "id": "red--lets-chill-cream-script-on-red",
    "name": "Lets Chill Cream Script On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/lets-chill-cream-script-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/lets-chill-cream-script-on-red.jpg")
  },
  {
    "id": "red--love-red-block-letters-on-white",
    "name": "Love Red Block Letters On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/love-red-block-letters-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/love-red-block-letters-on-white.jpg")
  },
  {
    "id": "red--love-yourself-first-cupid-angel-on-red",
    "name": "Love Yourself First Cupid Angel On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/love-yourself-first-cupid-angel-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/love-yourself-first-cupid-angel-on-red.jpg")
  },
  {
    "id": "red--lucky-black-heart-dice-in-rounded-panel",
    "name": "Lucky Black Heart Dice In Rounded Panel",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/lucky-black-heart-dice-in-rounded-panel.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/lucky-black-heart-dice-in-rounded-panel.jpg")
  },
  {
    "id": "red--lucky-girl-cream-script-on-red",
    "name": "Lucky Girl Cream Script On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/lucky-girl-cream-script-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/lucky-girl-cream-script-on-red.jpg")
  },
  {
    "id": "red--me-and-you-red-fingerprint-heart",
    "name": "Me And You Red Fingerprint Heart",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/me-and-you-red-fingerprint-heart.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/me-and-you-red-fingerprint-heart.jpg")
  },
  {
    "id": "red--nine-leopard-print-stars-on-red",
    "name": "Nine Leopard Print Stars On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/nine-leopard-print-stars-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/nine-leopard-print-stars-on-red.jpg")
  },
  {
    "id": "red--pale-pink-satin-bow-on-red",
    "name": "Pale Pink Satin Bow On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/pale-pink-satin-bow-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/pale-pink-satin-bow-on-red.jpg")
  },
  {
    "id": "red--self-love-affirmation-list-on-red",
    "name": "Self Love Affirmation List On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/self-love-affirmation-list-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/self-love-affirmation-list-on-red.jpg")
  },
  {
    "id": "red--stay-magnetic-cream-script-on-red",
    "name": "Stay Magnetic Cream Script On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/stay-magnetic-cream-script-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/stay-magnetic-cream-script-on-red.jpg")
  },
  {
    "id": "red--three-black-detailed-butterflies-on-white",
    "name": "Three Black Detailed Butterflies On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/three-black-detailed-butterflies-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/three-black-detailed-butterflies-on-white.jpg")
  },
  {
    "id": "red--three-leopard-print-lips-on-white",
    "name": "Three Leopard Print Lips On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/three-leopard-print-lips-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/three-leopard-print-lips-on-white.jpg")
  },
  {
    "id": "red--three-red-lipstick-kisses-on-white",
    "name": "Three Red Lipstick Kisses On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/three-red-lipstick-kisses-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/three-red-lipstick-kisses-on-white.jpg")
  },
  {
    "id": "red--three-white-outline-candy-hearts-on-red",
    "name": "Three White Outline Candy Hearts On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/three-white-outline-candy-hearts-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/three-white-outline-candy-hearts-on-red.jpg")
  },
  {
    "id": "red--twenty-red-sketched-hearts-on-white",
    "name": "Twenty Red Sketched Hearts On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/twenty-red-sketched-hearts-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/twenty-red-sketched-hearts-on-white.jpg")
  },
  {
    "id": "red--two-black-halftone-lips-on-white",
    "name": "Two Black Halftone Lips On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/two-black-halftone-lips-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/two-black-halftone-lips-on-white.jpg")
  },
  {
    "id": "red--two-glossy-red-cherries-on-white",
    "name": "Two Glossy Red Cherries On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/two-glossy-red-cherries-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/two-glossy-red-cherries-on-white.jpg")
  },
  {
    "id": "red--two-glossy-red-dice-on-white",
    "name": "Two Glossy Red Dice On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/two-glossy-red-dice-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/two-glossy-red-dice-on-white.jpg")
  },
  {
    "id": "red--two-pink-dice-with-red-hearts",
    "name": "Two Pink Dice With Red Hearts",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/two-pink-dice-with-red-hearts.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/two-pink-dice-with-red-hearts.jpg")
  },
  {
    "id": "red--two-red-halftone-lips-on-white",
    "name": "Two Red Halftone Lips On White",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/two-red-halftone-lips-on-white.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/two-red-halftone-lips-on-white.jpg")
  },
  {
    "id": "red--white-eyelash-eye-on-red",
    "name": "White Eyelash Eye On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/white-eyelash-eye-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/white-eyelash-eye-on-red.jpg")
  },
  {
    "id": "red--white-hand-drawn-spiral-on-red",
    "name": "White Hand Drawn Spiral On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/white-hand-drawn-spiral-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/white-hand-drawn-spiral-on-red.jpg")
  },
  {
    "id": "red--white-love-lettering-pattern-on-red",
    "name": "White Love Lettering Pattern On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/white-love-lettering-pattern-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/white-love-lettering-pattern-on-red.jpg")
  },
  {
    "id": "red--white-martini-glass-with-bow-on-red",
    "name": "White Martini Glass With Bow On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/white-martini-glass-with-bow-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/white-martini-glass-with-bow-on-red.jpg")
  },
  {
    "id": "red--yes-girl-you-can-cream-on-red",
    "name": "Yes Girl You Can Cream On Red",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/yes-girl-you-can-cream-on-red.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/yes-girl-you-can-cream-on-red.jpg")
  },
  {
    "id": "red--you-are-loved-heart-pink-polka-dot-stamp",
    "name": "You Are Loved Heart Pink Polka Dot Stamp",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/you-are-loved-heart-pink-polka-dot-stamp.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/you-are-loved-heart-pink-polka-dot-stamp.jpg")
  },
  {
    "id": "red--you-are-loved-white-wavy-panel-red-frame",
    "name": "You Are Loved White Wavy Panel Red Frame",
    "category": "Red",
    "src": window.StrayzyAsset("./assets/background-patterns/red/you-are-loved-white-wavy-panel-red-frame.jpg"),
    "thumb": window.StrayzyAsset("./assets/background-patterns/thumbs/red/you-are-loved-white-wavy-panel-red-frame.jpg")
  }
];
